// Generated by tools/build/i18n_bundle.py — do not edit by hand.
window.__GHD_LOCALES__ = [{"code": "en", "native": "English", "english": "English"}, {"code": "nl", "native": "Nederlands", "english": "Dutch"}, {"code": "de", "native": "Deutsch", "english": "German"}, {"code": "es", "native": "Español", "english": "Spanish"}, {"code": "fr", "native": "Français", "english": "French"}, {"code": "pt", "native": "Português", "english": "Portuguese"}, {"code": "it", "native": "Italiano", "english": "Italian"}, {"code": "hu", "native": "Magyar", "english": "Hungarian"}, {"code": "ru", "native": "Русский", "english": "Russian"}, {"code": "pl", "native": "Polski", "english": "Polish"}, {"code": "id", "native": "Bahasa Indonesia", "english": "Indonesian"}, {"code": "tr", "native": "Türkçe", "english": "Turkish"}, {"code": "ca", "native": "Català", "english": "Catalan"}, {"code": "uk", "native": "Українська", "english": "Ukrainian"}, {"code": "el", "native": "Ελληνικά", "english": "Greek"}, {"code": "cs", "native": "Čeština", "english": "Czech"}, {"code": "sv", "native": "Svenska", "english": "Swedish"}, {"code": "nb", "native": "Norsk", "english": "Norwegian"}, {"code": "ro", "native": "Română", "english": "Romanian"}, {"code": "fi", "native": "Suomi", "english": "Finnish"}, {"code": "th", "native": "ไทย", "english": "Thai"}, {"code": "vi", "native": "Tiếng Việt", "english": "Vietnamese"}, {"code": "bg", "native": "Български", "english": "Bulgarian"}, {"code": "da", "native": "Dansk", "english": "Danish"}, {"code": "ja", "native": "日本語", "english": "Japanese"}, {"code": "ko", "native": "한국어", "english": "Korean"}, {"code": "zh", "native": "繁體中文", "english": "Traditional Chinese", "bcp47": "zh-Hant"}];
window.__GHD_MSG_EN__ = {
  "action.close": "Close",
  "action.sign_in": "Sign in",
  "action.try_free": "Try it free",
  "app.ask_ai": "Ask AI:",
  "app.ask_ai_shuffle": "Show another example",
  "app.back_online": "Back online",
  "app.chart_down": "Down (HTTP {status})",
  "app.chart_healthy": "Healthy ({ms}ms)",
  "app.error_network": "Couldn't reach the server. Please check your connection and try again.",
  "app.error_server": "Something went wrong on our side. Please try again in a moment. If it keeps happening, email hello@gethumandesign.com.",
  "app.error_timeout": "The server took too long to answer. Please try again in a moment.",
  "app.offline_banner": "You're offline — connect to the internet to see your data",
  "app.page_load_failed": "This page didn't load",
  "app.page_load_failed_sub": "Check your connection and try again.",
  "app.page_load_retry": "Try again",
  "app.sign_in": "Sign in",
  "app.sign_out": "Sign out",
  "app.tab_chat": "Chat",
  "app.tab_nav_label": "Main navigation",
  "app.tab_people": "People",
  "app.tab_settings": "Settings",
  "app.tab_transits": "Transits",
  "app.title_transits": "Transits",
  "auth.ai_consent.label": "I agree to the {terms} and {privacy}, and that my birth data and chat messages are sent to {gemini} to write the AI's replies.",
  "auth.ai_consent.required": "Please agree to continue.",
  "auth.apple_continue": "Continue with Apple",
  "auth.apple_sign_in": "Sign in with Apple",
  "auth.email_typo.suggest": "Did you mean {email}?",
  "auth.error.account_exists": "You already have an account with this email.",
  "auth.error.email_not_confirmed": "Please open the confirmation link we emailed you first.",
  "auth.error.generic": "Something went wrong. Please try again.",
  "auth.error.invalid_credentials": "That email and password don’t match an account.",
  "auth.error.invalid_email": "Please enter a valid email address.",
  "auth.error.link_expired": "This link has expired. Request a new one and try again.",
  "auth.error.link_other_account": "This link belongs to a different account. Sign out first, then open it again.",
  "auth.error.missing_birth_fields": "Please fill in your birth date and birth place first.",
  "auth.error.oauth_start": "Could not start sign-in. Please try again.",
  "auth.error.password_min": "Please choose a password with at least 8 characters.",
  "auth.error.password_too_short": "Please choose a longer password (8+ characters).",
  "auth.error.same_password": "Your new password must be different from your current one.",
  "auth.error.too_many_attempts": "Too many attempts. Please wait a minute and try again.",
  "auth.github_sign_in": "Sign in with GitHub",
  "auth.google_continue": "Continue with Google",
  "auth.google_sign_in": "Sign in with Google",
  "auth.label.birth_date": "Birth date",
  "auth.label.birth_place": "Birth place",
  "auth.label.birth_time": "Birth time",
  "auth.label.email": "Email",
  "auth.label.new_password": "New password",
  "auth.label.password": "Password",
  "auth.login.forgot_password": "Forgot password?",
  "auth.login.no_account": "Don't have an account?",
  "auth.login.or_email": "or sign in with email",
  "auth.login.password_space_hint": "Your password starts or ends with a space. Check whether it belongs there.",
  "auth.login.provider_hint": "Signed up with Google or GitHub? Use the buttons below — those accounts have no password.",
  "auth.login.provider_hint_above": "Signed up with Apple, Google or GitHub? Use the buttons above — those accounts have no password.",
  "auth.login.signup_link": "Sign up",
  "auth.login.submit": "Sign in",
  "auth.login.title": "Sign in",
  "auth.placeholder.birth_place": "e.g. London, UK",
  "auth.placeholder.email": "you@example.com",
  "auth.placeholder.password": "At least 8 characters",
  "auth.reset.back_to_login": "Back to sign in",
  "auth.reset.submit": "Send reset link",
  "auth.reset.subtitle": "Enter your email and we'll send you a link to set a new password.",
  "auth.reset.success": "Check your email for a reset link.",
  "auth.reset.title": "Reset password",
  "auth.set_password.submit": "Update password",
  "auth.set_password.title": "Set new password",
  "auth.signup.confirm_body": "We sent a confirmation link to {email}. Open it on this device to finish creating your account.",
  "auth.signup.confirm_title": "Check your email",
  "auth.signup.cta": "Create account & open AI chat",
  "auth.signup.email_instead": "Sign up with email instead",
  "auth.signup.free_note": "Free. No credit card. No spam.",
  "auth.signup.google_instead": "Sign up with Google instead",
  "auth.signup.have_account": "Already have an account?",
  "auth.signup.no_time_hint": "No worries — we'll use 12:00 noon. You can update it later.",
  "auth.signup.providers_instead": "Sign up with Apple or Google instead",
  "auth.signup.resume_banner": "Your birth details are saved — just finish creating your account below.",
  "auth.signup.show_password": "Show password",
  "auth.signup.sign_in_instead": "Sign in instead",
  "auth.signup.subtitle": "Enter your birth details and we'll calculate your Human Design chart.",
  "auth.signup.time_known": "I know it",
  "auth.signup.time_not_sure": "I'm not sure",
  "auth.signup.time_required": "Please add your birth time, or tap “I'm not sure” if you don't know it.",
  "auth.signup.title": "Create your free account",
  "auth.signup.tos_and": "and",
  "auth.signup.tos_prefix": "By creating your account you agree to our",
  "auth.signup.tos_privacy": "Privacy Policy",
  "auth.signup.tos_terms": "Terms",
  "auth.social_divider": "or continue with",
  "bte.count_centers": "{n} centers",
  "bte.count_channels": "{n} channels",
  "bte.count_gates": "{n} gates",
  "bte.delta_earlier": "{span} earlier",
  "bte.delta_later": "{span} later",
  "bte.error_rate_limited": "Too many checks in a row — wait a moment, then adjust the time again.",
  "bte.hide_link": "Hide",
  "bte.hint_form": "Recorded times are often rounded. Drag the line, or click a time for details.",
  "bte.label": "Birth time check",
  "bte.loading": "Checking nearby birth times…",
  "bte.locked_title": "See how this chart shifts across the whole birth day",
  "bte.pro_tag": "Pro",
  "bte.probe_shift": "Stable between {start} and {end} — just outside, {props} would shift.",
  "bte.probe_stable": "This bodygraph is stable between {start} and {end}.",
  "bte.range_group": "Time window",
  "bte.range_locked": "{range} — Pro feature",
  "bte.readout_alt": "If born at {time} instead:",
  "bte.readout_chosen": "At your chosen time, {time}:",
  "bte.readout_differ": "differ",
  "bte.readout_flipped": "{items} flipped",
  "bte.readout_hold": "the headline layers hold",
  "bte.readout_none_flipped": "no activation flipped",
  "bte.row_stable": "Doesn't change in this window",
  "bte.scrub_aria": "Explore nearby birth times",
  "bte.seg_aria": "{label}: {value} from {start} to {end}",
  "bte.show_less": "Show less",
  "bte.show_more": "Show more",
  "bte.time_updated": "Time updated",
  "bte.upgrade": "Upgrade",
  "bte.upsell": "Pro adds wider nearby-time ranges and precision for every gate, channel and center.",
  "bte.use_time": "Use {time} as birth time",
  "bte.verdict_shift_sub": "Outside that window, {props} would shift.",
  "bte.verdict_stable": "Same bodygraph between {start} and {end}.",
  "bte.verdict_stable_sub": "Type, authority, profile, definition and cross all hold in this window.",
  "bte.verdict_window": "Same bodygraph between {start} and {end}.",
  "bte.verdict_window_open_end": "Same bodygraph from {start} until after {end}.",
  "bte.verdict_window_open_start": "Same bodygraph from before {start} until {end}.",
  "chart.adv_angle": "Angle",
  "chart.adv_birth_utc": "Birth in UTC",
  "chart.adv_chapter_arrows": "The arrows",
  "chart.adv_chapter_cross": "The cross",
  "chart.adv_chapter_dreamrave": "DreamRave",
  "chart.adv_chapter_numbers": "Behind the numbers",
  "chart.adv_chapter_zoom": "The layers",
  "chart.adv_cognition": "Cognition",
  "chart.adv_cross_english": "In English: {name}",
  "chart.adv_cross_gates": "Gates",
  "chart.adv_design_date": "Design date",
  "chart.adv_determination": "Determination",
  "chart.adv_direction_left": "Left · active",
  "chart.adv_direction_right": "Right · passive",
  "chart.adv_distraction": "Distraction",
  "chart.adv_dreamrave_about": "What is DreamRave?",
  "chart.adv_dreamrave_asleep": "Asleep",
  "chart.adv_dreamrave_awake": "Awake: {type}",
  "chart.adv_dreamrave_awake_tab": "Awake",
  "chart.adv_dreamrave_channels": "Sleep channels",
  "chart.adv_dreamrave_defined_centers": "Defined at night",
  "chart.adv_dreamrave_design_note": "The Design side is the moment the Moon stood 88° before its birth position, about a week before birth.",
  "chart.adv_dreamrave_field_demon_realm": "Demon Realm",
  "chart.adv_dreamrave_field_earth_plane": "Earth Plane",
  "chart.adv_dreamrave_field_light_field": "Light Field",
  "chart.adv_dreamrave_graph_label": "Sleep chart: {type} at night",
  "chart.adv_dreamrave_key_channel": "Sleep channel, not active",
  "chart.adv_dreamrave_key_offline": "Offline in sleep",
  "chart.adv_dreamrave_key_portal": "Portal gate: its partner is offline",
  "chart.adv_dreamrave_needs_time": "Needs an exact birth time",
  "chart.adv_dreamrave_none": "None",
  "chart.adv_dreamrave_open": "Open the sleep chart",
  "chart.adv_dreamrave_open_centers": "Open at night",
  "chart.adv_dreamrave_title": "Sleep chart",
  "chart.adv_dreamrave_type": "Type at night",
  "chart.adv_dreamrave_view_label": "Show the chart asleep or awake",
  "chart.adv_dst": "DST",
  "chart.adv_empty_sub": "Something went wrong building it. Reloading the page usually fixes it.",
  "chart.adv_empty_title": "This tab could not be drawn",
  "chart.adv_environment": "Environment",
  "chart.adv_fix_detriment": "Detriment",
  "chart.adv_fix_exalted": "Exalted",
  "chart.adv_fix_juxtaposed": "Juxtaposed",
  "chart.adv_godhead": "Godhead",
  "chart.adv_hold_share": "holds for {pct} of the birth day",
  "chart.adv_hold_sub": "Some arrows keep one value for most of the day. This is how much of it each one holds.",
  "chart.adv_hold_title": "What the birth day can still say",
  "chart.adv_locked_sub_approx": "The arrows are read from the finest layer of a chart, which can turn over in minutes — an approximate hour easily points them the wrong way.",
  "chart.adv_locked_sub_unknown": "The arrows are read from the finest layer of a chart, which turns over in minutes. Without the birth hour they would be someone else's.",
  "chart.adv_locked_title": "Variable needs an exact birth time",
  "chart.adv_more": "{n} more",
  "chart.adv_motivation": "Motivation",
  "chart.adv_perspective": "Perspective",
  "chart.adv_quarter": "Quarter",
  "chart.adv_quarter_n": "Quarter {n}",
  "chart.adv_section_calculation": "Calculation",
  "chart.adv_section_fixing": "Fixing",
  "chart.adv_section_mind": "Rave Psychology",
  "chart.adv_section_overlay": "Astrology overlay",
  "chart.adv_section_phs": "PHS",
  "chart.adv_substructure_line": "Color {color} · Tone {tone} · Base {base}",
  "chart.adv_timezone": "Time zone",
  "chart.adv_transference": "Transference",
  "chart.arrow_left": "arrow left",
  "chart.arrow_right": "arrow right",
  "chart.authority": "Authority",
  "chart.authority_name.ego": "Ego",
  "chart.authority_name.emotional": "Emotional",
  "chart.authority_name.lunar": "Lunar",
  "chart.authority_name.mental": "Mental",
  "chart.authority_name.sacral": "Sacral",
  "chart.authority_name.self_projected": "Self-Projected",
  "chart.authority_name.splenic": "Splenic",
  "chart.bg_drawing": "Bodygraph. Arrow keys move between its gates, centers and arrows; Enter opens one.",
  "chart.bg_tip_center_g": "G center",
  "chart.bg_tip_points_left": "points left",
  "chart.bg_tip_points_right": "points right",
  "chart.bridging_gates": "Bridging gates",
  "chart.center.ajna": "Ajna",
  "chart.center.g": "G",
  "chart.center.head": "Head",
  "chart.center.heart": "Heart",
  "chart.center.root": "Root",
  "chart.center.sacral": "Sacral",
  "chart.center.solarplexus": "Solar Plexus",
  "chart.center.spleen": "Spleen",
  "chart.center.throat": "Throat",
  "chart.center_defined": "Defined",
  "chart.center_undefined": "Undefined",
  "chart.centers": "Centers",
  "chart.channel.1-8": "Inspiration",
  "chart.channel.10-20": "Awakening",
  "chart.channel.10-34": "Exploration",
  "chart.channel.10-57": "Perfected Form",
  "chart.channel.11-56": "Curiosity",
  "chart.channel.12-22": "Openness",
  "chart.channel.13-33": "The Prodigal",
  "chart.channel.16-48": "The Wavelength",
  "chart.channel.17-62": "Acceptance",
  "chart.channel.18-58": "Judgement",
  "chart.channel.19-49": "Synthesis",
  "chart.channel.2-14": "The Beat",
  "chart.channel.20-34": "Charisma",
  "chart.channel.20-57": "The Brainwave",
  "chart.channel.21-45": "The Money Line",
  "chart.channel.23-43": "Structuring",
  "chart.channel.24-61": "Awareness",
  "chart.channel.25-51": "Initiation",
  "chart.channel.26-44": "Surrender",
  "chart.channel.27-50": "Preservation",
  "chart.channel.28-38": "Struggle",
  "chart.channel.29-46": "Discovery",
  "chart.channel.3-60": "Mutation",
  "chart.channel.30-41": "Recognition",
  "chart.channel.32-54": "Transformation",
  "chart.channel.34-57": "Power",
  "chart.channel.35-36": "Transitoriness",
  "chart.channel.37-40": "Community",
  "chart.channel.39-55": "Emoting",
  "chart.channel.4-63": "Logic",
  "chart.channel.42-53": "Maturation",
  "chart.channel.47-64": "Abstraction",
  "chart.channel.5-15": "Rhythm",
  "chart.channel.6-59": "Mating",
  "chart.channel.7-31": "The Alpha",
  "chart.channel.9-52": "Concentration",
  "chart.channels": "Channels",
  "chart.circuit_centering": "Centering",
  "chart.circuit_defense": "Defense",
  "chart.circuit_ego": "Ego",
  "chart.circuit_group_collective": "Collective",
  "chart.circuit_group_individual": "Individual",
  "chart.circuit_group_integration": "Integration",
  "chart.circuit_group_tribal": "Tribal",
  "chart.circuit_key_hanging": "Hanging gate",
  "chart.circuit_knowing": "Knowing",
  "chart.circuit_mix_balance": "{a} and {b} in balance",
  "chart.circuit_mix_mostly": "Mostly {family}",
  "chart.circuit_mix_one": "One channel, {family}",
  "chart.circuit_sensing": "Sensing",
  "chart.circuit_understanding": "Understanding",
  "chart.circuitry": "Circuitry",
  "chart.circuits_on_bodygraph": "See the circuits on the bodygraph",
  "chart.clock_12h": "{time} ({part})",
  "chart.clock_12h_24h": "{time} ({part}, {clock})",
  "chart.clock_am": "{hour} AM",
  "chart.clock_hint_style": "12h",
  "chart.clock_midnight": "midnight",
  "chart.clock_noon": "noon",
  "chart.clock_part_afternoon": "afternoon",
  "chart.clock_part_evening": "evening",
  "chart.clock_part_morning": "morning",
  "chart.clock_part_night": "night",
  "chart.clock_pm": "{hour} PM",
  "chart.compare_circuit_together": "Together you complete {n} channels neither holds alone: {mix}",
  "chart.compare_circuit_together_one": "Together you complete one channel neither holds alone: {mix}",
  "chart.cross": "Cross",
  "chart.cross_angle.juxtaposition": "Juxtaposition",
  "chart.cross_angle.left_angle": "Left Angle",
  "chart.cross_angle.right_angle": "Right Angle",
  "chart.cross_name.jxp.alertness": "Juxtaposition Cross of Alertness",
  "chart.cross_name.jxp.ambition": "Juxtaposition Cross of Ambition",
  "chart.cross_name.jxp.articulation": "Juxtaposition Cross of Articulation",
  "chart.cross_name.jxp.assimilation": "Juxtaposition Cross of Assimilation",
  "chart.cross_name.jxp.bargains": "Juxtaposition Cross of Bargains",
  "chart.cross_name.jxp.beginnings": "Juxtaposition Cross of Beginnings",
  "chart.cross_name.jxp.behavior": "Juxtaposition Cross of Behavior",
  "chart.cross_name.jxp.caring": "Juxtaposition Cross of Caring",
  "chart.cross_name.jxp.commitment": "Juxtaposition Cross of Commitment",
  "chart.cross_name.jxp.completion": "Juxtaposition Cross of Completion",
  "chart.cross_name.jxp.conflict": "Juxtaposition Cross of Conflict",
  "chart.cross_name.jxp.confusion": "Juxtaposition Cross of Confusion",
  "chart.cross_name.jxp.conservation": "Juxtaposition Cross of Conservation",
  "chart.cross_name.jxp.contribution": "Juxtaposition Cross of Contribution",
  "chart.cross_name.jxp.control": "Juxtaposition Cross of Control",
  "chart.cross_name.jxp.correction": "Juxtaposition Cross of Correction",
  "chart.cross_name.jxp.crisis": "Juxtaposition Cross of Crisis",
  "chart.cross_name.jxp.denial": "Juxtaposition Cross of Denial",
  "chart.cross_name.jxp.depth": "Juxtaposition Cross of Depth",
  "chart.cross_name.jxp.detail": "Juxtaposition Cross of Detail",
  "chart.cross_name.jxp.doubts": "Juxtaposition Cross of Doubts",
  "chart.cross_name.jxp.empowering": "Juxtaposition Cross of Empowering",
  "chart.cross_name.jxp.experience": "Juxtaposition Cross of Experience",
  "chart.cross_name.jxp.experimentation": "Juxtaposition Cross of Experimentation",
  "chart.cross_name.jxp.extremes": "Juxtaposition Cross of Extremes",
  "chart.cross_name.jxp.fantasy": "Juxtaposition Cross of Fantasy",
  "chart.cross_name.jxp.fates": "Juxtaposition Cross of Fates",
  "chart.cross_name.jxp.focus": "Juxtaposition Cross of Focus",
  "chart.cross_name.jxp.formulization": "Juxtaposition Cross of Formulization",
  "chart.cross_name.jxp.grace": "Juxtaposition Cross of Grace",
  "chart.cross_name.jxp.habits": "Juxtaposition Cross of Habits",
  "chart.cross_name.jxp.ideas": "Juxtaposition Cross of Ideas",
  "chart.cross_name.jxp.influence": "Juxtaposition Cross of Influence",
  "chart.cross_name.jxp.innocence": "Juxtaposition Cross of Innocence",
  "chart.cross_name.jxp.insight": "Juxtaposition Cross of Insight",
  "chart.cross_name.jxp.interaction": "Juxtaposition Cross of Interaction",
  "chart.cross_name.jxp.intuition": "Juxtaposition Cross of Intuition",
  "chart.cross_name.jxp.limitation": "Juxtaposition Cross of Limitation",
  "chart.cross_name.jxp.listening": "Juxtaposition Cross of Listening",
  "chart.cross_name.jxp.moods": "Juxtaposition Cross of Moods",
  "chart.cross_name.jxp.mutation": "Juxtaposition Cross of Mutation",
  "chart.cross_name.jxp.need": "Juxtaposition Cross of Need",
  "chart.cross_name.jxp.opinions": "Juxtaposition Cross of Opinions",
  "chart.cross_name.jxp.opposition": "Juxtaposition Cross of Opposition",
  "chart.cross_name.jxp.oppression": "Juxtaposition Cross of Oppression",
  "chart.cross_name.jxp.possession": "Juxtaposition Cross of Possession",
  "chart.cross_name.jxp.power": "Juxtaposition Cross of Power",
  "chart.cross_name.jxp.principles": "Juxtaposition Cross of Principles",
  "chart.cross_name.jxp.provocation": "Juxtaposition Cross of Provocation",
  "chart.cross_name.jxp.rationalization": "Juxtaposition Cross of Rationalization",
  "chart.cross_name.jxp.retreat": "Juxtaposition Cross of Retreat",
  "chart.cross_name.jxp.risks": "Juxtaposition Cross of Risks",
  "chart.cross_name.jxp.self_expression": "Juxtaposition Cross of Self-Expression",
  "chart.cross_name.jxp.serendipity": "Juxtaposition Cross of Serendipity",
  "chart.cross_name.jxp.shock": "Juxtaposition Cross of Shock",
  "chart.cross_name.jxp.stillness": "Juxtaposition Cross of Stillness",
  "chart.cross_name.jxp.stimulation": "Juxtaposition Cross of Stimulation",
  "chart.cross_name.jxp.strategy": "Juxtaposition Cross of Strategy",
  "chart.cross_name.jxp.the_driver": "Juxtaposition Cross of the Driver",
  "chart.cross_name.jxp.the_now": "Juxtaposition Cross of the Now",
  "chart.cross_name.jxp.the_trickster": "Juxtaposition Cross of the Trickster",
  "chart.cross_name.jxp.thinking": "Juxtaposition Cross of Thinking",
  "chart.cross_name.jxp.values": "Juxtaposition Cross of Values",
  "chart.cross_name.jxp.vitality": "Juxtaposition Cross of Vitality",
  "chart.cross_name.lac.alignment": "Left Angle Cross of Alignment",
  "chart.cross_name.lac.confrontation": "Left Angle Cross of Confrontation",
  "chart.cross_name.lac.cycles": "Left Angle Cross of Cycles",
  "chart.cross_name.lac.dedication": "Left Angle Cross of Dedication",
  "chart.cross_name.lac.defiance": "Left Angle Cross of Defiance",
  "chart.cross_name.lac.demands": "Left Angle Cross of Demands",
  "chart.cross_name.lac.distraction": "Left Angle Cross of Distraction",
  "chart.cross_name.lac.dominion": "Left Angle Cross of Dominion",
  "chart.cross_name.lac.duality": "Left Angle Cross of Duality",
  "chart.cross_name.lac.education": "Left Angle Cross of Education",
  "chart.cross_name.lac.endeavour": "Left Angle Cross of Endeavour",
  "chart.cross_name.lac.healing": "Left Angle Cross of Healing",
  "chart.cross_name.lac.identification": "Left Angle Cross of Identification",
  "chart.cross_name.lac.incarnation": "Left Angle Cross of Incarnation",
  "chart.cross_name.lac.individualism": "Left Angle Cross of Individualism",
  "chart.cross_name.lac.industry": "Left Angle Cross of Industry",
  "chart.cross_name.lac.informing": "Left Angle Cross of Informing",
  "chart.cross_name.lac.limitation": "Left Angle Cross of Limitation",
  "chart.cross_name.lac.masks": "Left Angle Cross of Masks",
  "chart.cross_name.lac.migration": "Left Angle Cross of Migration",
  "chart.cross_name.lac.obscuration": "Left Angle Cross of Obscuration",
  "chart.cross_name.lac.prevention": "Left Angle Cross of Prevention",
  "chart.cross_name.lac.refinement": "Left Angle Cross of Refinement",
  "chart.cross_name.lac.revolution": "Left Angle Cross of Revolution",
  "chart.cross_name.lac.separation": "Left Angle Cross of Separation",
  "chart.cross_name.lac.spirit": "Left Angle Cross of Spirit",
  "chart.cross_name.lac.the_alpha": "Left Angle Cross of the Alpha",
  "chart.cross_name.lac.the_clarion": "Left Angle Cross of the Clarion",
  "chart.cross_name.lac.the_plane": "Left Angle Cross of the Plane",
  "chart.cross_name.lac.uncertainty": "Left Angle Cross of Uncertainty",
  "chart.cross_name.lac.upheaval": "Left Angle Cross of Upheaval",
  "chart.cross_name.lac.wishes": "Left Angle Cross of Wishes",
  "chart.cross_name.rac.consciousness": "Right Angle Cross of Consciousness",
  "chart.cross_name.rac.contagion": "Right Angle Cross of Contagion",
  "chart.cross_name.rac.eden": "Right Angle Cross of Eden",
  "chart.cross_name.rac.explanation": "Right Angle Cross of Explanation",
  "chart.cross_name.rac.laws": "Right Angle Cross of Laws",
  "chart.cross_name.rac.maya": "Right Angle Cross of Maya",
  "chart.cross_name.rac.penetration": "Right Angle Cross of Penetration",
  "chart.cross_name.rac.planning": "Right Angle Cross of Planning",
  "chart.cross_name.rac.rulership": "Right Angle Cross of Rulership",
  "chart.cross_name.rac.service": "Right Angle Cross of Service",
  "chart.cross_name.rac.tension": "Right Angle Cross of Tension",
  "chart.cross_name.rac.the_four_ways": "Right Angle Cross of the Four Ways",
  "chart.cross_name.rac.the_sleeping_phoenix": "Right Angle Cross of the Sleeping Phoenix",
  "chart.cross_name.rac.the_sphinx": "Right Angle Cross of the Sphinx",
  "chart.cross_name.rac.the_unexpected": "Right Angle Cross of the Unexpected",
  "chart.cross_name.rac.vessel_of_love": "Right Angle Cross of Vessel of Love",
  "chart.cycle_card_pass": "pass {n} of {total}",
  "chart.cycle_card_title": "{cycle} for {name}",
  "chart.cycles_card_aria": "{name}'s returns from birth to age {age}",
  "chart.cycles_card_next": "{cycle} in {year}",
  "chart.cycles_card_next_about": "{cycle} around {year}",
  "chart.cycles_card_now": "{cycle} now",
  "chart.cycles_card_open": "Open cycles",
  "chart.cycles_card_solar_next": "Next Solar return: {date}",
  "chart.cycles_card_title": "Cycles for {name}",
  "chart.cycles_card_title_self": "Your cycles",
  "chart.definition": "Definition",
  "chart.definition_name.no_definition": "No Definition",
  "chart.definition_name.quadruple_split_definition": "Quadruple Split Definition",
  "chart.definition_name.single_definition": "Single Definition",
  "chart.definition_name.split_definition": "Split Definition",
  "chart.definition_name.triple_split_definition": "Triple Split Definition",
  "chart.design_header": "Design",
  "chart.dreamrave_card_all_open": "Nothing is defined at night: all five centers are open.",
  "chart.dreamrave_card_open": "Open the Advanced tab",
  "chart.dreamrave_card_summary": "Defined: {defined}. Open: {open}.",
  "chart.dreamrave_card_title": "{name}: {type} at night",
  "chart.fix_detriment": "Detriment — challenging expression",
  "chart.fix_exalted": "Exalted — harmonious expression",
  "chart.fix_juxtaposed": "Juxtaposed — both states present",
  "chart.gates": "Gates",
  "chart.godhead.christ_consciousness_field": "the Christ Consciousness Field",
  "chart.godhead.hades": "Hades",
  "chart.godhead.harmonia": "Harmonia",
  "chart.godhead.janus": "Janus",
  "chart.godhead.kali": "Kali",
  "chart.godhead.keepers_of_the_wheel": "the Keepers of the Wheel",
  "chart.godhead.lakshmi": "Lakshmi",
  "chart.godhead.maat": "Ma'at",
  "chart.godhead.maia": "Maia",
  "chart.godhead.michael": "Michael",
  "chart.godhead.minerva": "Minerva",
  "chart.godhead.mitra": "Mitra",
  "chart.godhead.parvati": "Parvati",
  "chart.godhead.prometheus": "Prometheus",
  "chart.godhead.thoth": "Thoth",
  "chart.godhead.vishnu": "Vishnu",
  "chart.legend_both": "Both",
  "chart.legend_design": "Design (unconscious)",
  "chart.legend_open": "Open",
  "chart.legend_personality": "Personality (conscious)",
  "chart.loading": "Loading…",
  "chart.locked_bodygraph_sub_approx": "Gates and channels shift through the day, so an approximate hour can easily draw the wrong ones.",
  "chart.locked_bodygraph_sub_unknown": "Gates and channels shift through the day. Without the birth hour we'd be drawing a stand-in one, and that bodygraph belongs to someone else.",
  "chart.locked_bodygraph_title": "The bodygraph needs an exact birth time",
  "chart.locked_lists_sub_approx": "They open and close as the day turns, and an approximate hour can land on the wrong side of a switch.",
  "chart.locked_lists_sub_unknown": "They open and close as the day turns. Without the birth hour we'd be listing someone else's.",
  "chart.locked_lists_title": "Channels and gates need an exact birth time",
  "chart.locked_planets_sub_approx": "Planets keep moving all day — the Moon alone crosses about 12°. From an approximate hour, this table would be precision we don't have.",
  "chart.locked_planets_sub_unknown": "Planets keep moving all day — the Moon alone crosses about 12°. Without the birth hour, this table would be precision we don't have.",
  "chart.locked_planets_title": "The planets need an exact birth time",
  "chart.needs_exact_time": "needs exact time",
  "chart.needs_time_add": "Add birth time",
  "chart.needs_time_update": "Update birth time",
  "chart.no_centers": "No centers.",
  "chart.no_channels": "No defined channels.",
  "chart.no_gates": "No defined gates.",
  "chart.no_window_channels": "No channel is defined across more than 60% of this window.",
  "chart.no_window_gates": "No gate is active across more than 60% of this window.",
  "chart.no_window_planets": "No planetary placement holds across the whole of this window.",
  "chart.not_self": "Not-Self",
  "chart.not_self_name.generator": "Frustration",
  "chart.not_self_name.manifesting_generator": "Frustration",
  "chart.not_self_name.manifestor": "Anger",
  "chart.not_self_name.projector": "Bitterness",
  "chart.not_self_name.reflector": "Disappointment",
  "chart.pair_transit_card_title": "Transits for {a} & {b}",
  "chart.pdf_ask_ai": "Explain this bodygraph with AI",
  "chart.pdf_channels": "Defined Channels",
  "chart.pdf_circuit": "{group} ({circuit})",
  "chart.pdf_generated_at": "Generated at gethumandesign.com",
  "chart.pdf_needs_exact_time": "The PDF needs an exact birth time. Add it and the sheet is yours.",
  "chart.pdf_planet_column": "Planet",
  "chart.pdf_planets": "Planet Activations",
  "chart.pdf_properties": "Chart Properties",
  "chart.pdf_ready": "Your PDF is ready.",
  "chart.personality_header": "Personality",
  "chart.planet.earth": "Earth",
  "chart.planet.jupiter": "Jupiter",
  "chart.planet.mars": "Mars",
  "chart.planet.mercury": "Mercury",
  "chart.planet.moon": "Moon",
  "chart.planet.neptune": "Neptune",
  "chart.planet.northnode": "North Node",
  "chart.planet.northnode_short": "N.Node",
  "chart.planet.pluto": "Pluto",
  "chart.planet.saturn": "Saturn",
  "chart.planet.southnode": "South Node",
  "chart.planet.southnode_short": "S.Node",
  "chart.planet.sun": "Sun",
  "chart.planet.uranus": "Uranus",
  "chart.planet.venus": "Venus",
  "chart.profile": "Profile",
  "chart.profile_line.1": "Investigator",
  "chart.profile_line.2": "Hermit",
  "chart.profile_line.3": "Martyr",
  "chart.profile_line.4": "Opportunist",
  "chart.profile_line.5": "Heretic",
  "chart.profile_line.6": "Role Model",
  "chart.profile_name_pair": "{first} / {second}",
  "chart.quarter_name.civilization": "Civilization",
  "chart.quarter_name.duality": "Duality",
  "chart.quarter_name.initiation": "Initiation",
  "chart.quarter_name.mutation": "Mutation",
  "chart.retrograde_legend": "Retrograde — astronomy we report, not a Human Design reading",
  "chart.section_channels_gates": "Channels & gates",
  "chart.section_channels_gates_centers": "Channels, gates & centers",
  "chart.section_design": "Design",
  "chart.see_whole_day": "See the whole day",
  "chart.show_substructure": "Show Color · Tone · Base",
  "chart.signature": "Signature",
  "chart.signature_name.generator": "Satisfaction",
  "chart.signature_name.manifesting_generator": "Satisfaction",
  "chart.signature_name.manifestor": "Peace",
  "chart.signature_name.projector": "Success",
  "chart.signature_name.reflector": "Surprise",
  "chart.sky_key_amplified": "Amplified",
  "chart.sky_key_background": "Background",
  "chart.sky_key_center": "Activated by the sky",
  "chart.sky_key_direct": "Direct",
  "chart.sky_key_group_centers": "The sky — centers",
  "chart.sky_key_group_channels": "The sky — channels",
  "chart.sky_key_hanging": "Hanging gate",
  "chart.sky_key_lit": "Lit by the sky",
  "chart.sky_key_pair": "{a} & {b}",
  "chart.sky_key_pair_shared": "Both",
  "chart.sky_key_shared": "Both",
  "chart.sky_key_sky": "The sky",
  "chart.sky_key_you": "You",
  "chart.strategy": "Strategy",
  "chart.strategy_name.generator": "To Respond",
  "chart.strategy_name.manifesting_generator": "To Respond",
  "chart.strategy_name.manifestor": "To Inform",
  "chart.strategy_name.projector": "Wait for the Invitation",
  "chart.strategy_name.reflector": "Wait a Lunar Cycle",
  "chart.tier_certain": "Certain",
  "chart.tier_certain_means": "true at every minute of that window",
  "chart.tier_counts_label": "{certain} certain · {likely} likely",
  "chart.tier_likely": "Likely",
  "chart.tier_likely_means": "true across more than 60% of it",
  "chart.tier_one_ink": "We need the exact minute to tell Design from Personality, so the chart is drawn in one colour.",
  "chart.tier_open_means": "Anything less certain than that depends on the exact minute, so we leave it open.",
  "chart.tier_rule": "Certain means true at every minute we checked. Likely means true for more than 60% of them.",
  "chart.transit_card_center": "+{n} center",
  "chart.transit_card_centers": "+{n} centers",
  "chart.transit_card_channel": "+{n} channel",
  "chart.transit_card_channels": "+{n} channels",
  "chart.transit_card_quiet": "No extra channels or centers",
  "chart.transit_card_title": "Transits for {name}",
  "chart.type": "Type",
  "chart.type_name.generator": "Generator",
  "chart.type_name.manifesting_generator": "Manifesting Generator",
  "chart.type_name.manifestor": "Manifestor",
  "chart.type_name.projector": "Projector",
  "chart.type_name.reflector": "Reflector",
  "chart.view_aria": "Bodygraph view",
  "chart.view_bridge_tip": "would join {a} and {b}",
  "chart.view_bridges": "Bridges",
  "chart.view_bridges_empty": "No center is defined, so there is nothing to bridge.",
  "chart.view_bridges_four": "Four areas that do not touch.",
  "chart.view_bridges_join_many": "Gates {gates} would each join them.",
  "chart.view_bridges_join_many_of": "Gates {gates} would each join two of them.",
  "chart.view_bridges_join_one": "Gate {gate} would join them.",
  "chart.view_bridges_join_one_of": "Gate {gate} would join two of them.",
  "chart.view_bridges_none": "No single gate joins them; it takes a whole channel.",
  "chart.view_bridges_single": "The definition is one piece, so nothing needs a bridge.",
  "chart.view_bridges_three": "Three areas that do not touch.",
  "chart.view_bridges_two": "Two areas that do not touch.",
  "chart.view_circuits": "Circuits",
  "chart.view_circuits_none": "No complete channel, so no circuit to color.",
  "chart.view_circuits_summary": "Colored by circuit instead of side.",
  "chart.view_key_bridge": "Bridging gate",
  "chart.view_likely_note": "Drawn from the likely chart, because the birth time is not exact.",
  "chart.view_sides": "Sides",
  "chart.view_sides_likely_summary": "Shaded by how much of the birth-time window each shape holds for.",
  "chart.view_sides_summary": "Each gate wears the side that activated it: Personality, Design or both.",
  "chart.view_transit": "Transit",
  "chart.view_transit_error": "The sky could not be read just now.",
  "chart.view_transit_loading": "Reading the sky…",
  "chart.view_transit_locked": "The sky over this chart is part of Pro.",
  "chart.view_transit_open": "Open transits",
  "chart.view_transit_pro": "Transit, part of Pro",
  "chart.view_transit_summary": "The sky now, at {time}, over this chart.",
  "chart.view_transit_upgrade": "See what Pro adds",
  "chart.window_all_certain": "Nothing in this bodygraph changes across that window, so this is their chart whatever the exact minute was.",
  "chart.window_because_roughly": "This chart is saved with birth time accuracy Roughly, around {time}, so we checked {from}–{to}.",
  "chart.window_because_span": "This chart was checked across {from}–{to}.",
  "chart.window_because_unknown": "This chart is saved with birth time accuracy Unknown, so we checked the whole birth day.",
  "chart.window_body": "Everything shown holds for most of those hours, and the exact minute would settle the rest.",
  "chart.window_checked_day": "Checked across the whole birth day",
  "chart.window_checked_span": "Checked across {from}–{to}",
  "chart.window_explain_roughly": "This birth time is saved as Roughly, around {time}, so we checked every minute between {from} and {to}. Certain holds at every one of them. Likely holds at more than 60% of them. Anything that holds less often is left open, because it depends on the exact minute.",
  "chart.window_explain_unknown": "This birth time is saved as Unknown, so we checked every minute of the birth day. Certain holds at every one of them. Likely holds at more than 60% of them. Anything that holds less often is left open, because it depends on the exact minute.",
  "chart.window_fix_hint": "Set the accuracy to Exact in this person's details when you know the time.",
  "chart.window_head_day": "We checked the whole birth day",
  "chart.window_head_span": "We checked {from}–{to}",
  "chart.window_items_note": "Everything that holds across more than 60% of the window is listed, marked by how much of the window backs it.",
  "chart.window_planets_note": "A clock marks what needs the exact birth time. After a gate number, only the line does; on its own, the gate does too.",
  "chart.window_whole_day": "whole day",
  "chat.all_chats": "All chats",
  "chat.busy_body": "Our chat runs on Google's AI servers, and they're overloaded at the moment. This reply couldn't be finished, and it doesn't count toward your message limit.",
  "chat.busy_retry_in": "Trying again in {seconds} s",
  "chat.busy_retrying": "Trying again…",
  "chat.busy_still": "Still busy. Please try again in a few minutes.",
  "chat.busy_title": "The AI behind this chat is very busy right now",
  "chat.busy_try_again": "Try again",
  "chat.busy_try_now": "Try now",
  "chat.cancel": "Cancel",
  "chat.card_age": "{age} yr",
  "chat.card_bodygraph_needs_time": "Needs an exact birth time",
  "chat.card_group_pro": "Groups are Pro",
  "chat.card_group_saved": "Group saved",
  "chat.card_limit_upgrade": "Upgrade",
  "chat.card_open_bodygraph": "Open bodygraph",
  "chat.card_open_pair_transits": "Open the pair's transits",
  "chat.card_open_transits": "Open transits",
  "chat.card_save": "Save to my people",
  "chat.card_save_cancel": "Cancel",
  "chat.card_save_confirm": "Save",
  "chat.card_save_duplicate": "Already in your people",
  "chat.card_save_group": "Save group",
  "chat.card_save_group_name": "Group name",
  "chat.card_save_name": "Name",
  "chat.card_save_retry": "Couldn’t save — retry",
  "chat.card_saved": "Saved to my people",
  "chat.card_saving": "Saving…",
  "chat.card_time_check": "Check",
  "chat.card_time_roughly": "±{time}",
  "chat.card_time_unknown": "time unknown",
  "chat.chat_context": "Chat context",
  "chat.close": "Close",
  "chat.compare_card_centers": "{defined}/9 centers",
  "chat.compare_card_companionship": "companionship",
  "chat.compare_card_compromise": "compromise",
  "chat.compare_card_dominance": "dominance",
  "chat.compare_card_electromagnetic": "electromagnetic",
  "chat.compare_card_eyebrow": "Connection",
  "chat.compare_card_together": "Together:",
  "chat.compare_theme_better_to_be_free": "Better to be free",
  "chat.compare_theme_have_some_fun": "Have some fun",
  "chat.compare_theme_not_a_relationship_anymore": "Not a relationship anymore",
  "chat.compare_theme_nowhere_to_go": "Nowhere to go",
  "chat.compare_theme_work_to_do": "Work to do",
  "chat.composer_label": "Your message",
  "chat.context_add_people": "Add your people",
  "chat.context_pin_time": "Pin down your birth time",
  "chat.conversation_not_found": "Conversation not found.",
  "chat.conversations": "Conversations",
  "chat.copied": "Copied!",
  "chat.copy": "Copy",
  "chat.copy_failed": "Copy failed",
  "chat.creating": "Creating…",
  "chat.delete_turn": "Delete message",
  "chat.delete_turn_confirm": "Delete this message and its reply?",
  "chat.delete_turn_failed": "Couldn't delete the message. Please try again.",
  "chat.delete_turn_only": "It's the only message in this chat, so the whole chat is deleted.",
  "chat.delete_turn_sub": "This can't be undone.",
  "chat.dismiss": "Dismiss",
  "chat.download_app": "Download app",
  "chat.draft_restored": "We kept the message you hadn't sent yet.",
  "chat.edit_resubmit": "Edit and resubmit",
  "chat.err_create_share": "Couldn't create the share link. Please try again.",
  "chat.err_load_messages": "Couldn't load the messages. Please try again.",
  "chat.err_message_too_long": "That’s too much text for one message — trim it to {max} characters or fewer and send again.",
  "chat.err_stop_sharing": "Couldn't stop sharing. Please try again.",
  "chat.exit_private_chat": "Exit private chat",
  "chat.failed": "Failed",
  "chat.feedback": "Feedback",
  "chat.feedback_card_body": "A copy is on its way to {email}. We read every message and reply there if needed.",
  "chat.feedback_card_body_generic": "A copy is on its way to your inbox. We read every message and reply by email if needed.",
  "chat.feedback_card_title": "Feedback sent — thank you",
  "chat.feedback_intro": "We'd love to hear from you. You can also email us directly at",
  "chat.feedback_intro_named": "Hi {name}, we'd love to hear from you. You can also email us directly at",
  "chat.feedback_placeholder": "What's on your mind?",
  "chat.feedback_title": "Send feedback",
  "chat.finishing_after_drop": "Connection dropped — your reply is still being written and will appear here.",
  "chat.first_journey_next": "What would you like to explore next?",
  "chat.greeting": "Hello!",
  "chat.greeting_named": "Hello, {name}!",
  "chat.group_card_members": "{count} members",
  "chat.group_card_names": "{names} & {last}",
  "chat.group_card_penta": "Penta {defined}/6",
  "chat.group_card_you": "you",
  "chat.home": "Home",
  "chat.install_firefox": "Tap the ⋮ menu, then \"Install\"",
  "chat.install_ios": "Tap the Share button, then \"Add to Home Screen\"",
  "chat.install_other": "Tap the browser menu, then \"Install app\" or \"Add to Home Screen\"",
  "chat.language_card_body": "The whole app moves with it — menus, chat replies and emails.",
  "chat.language_card_confirm": "Switch to English",
  "chat.language_card_not_now": "Not now",
  "chat.language_card_subtitle": "Change the app's language.",
  "chat.language_card_switched": "Done — your language is now English.",
  "chat.language_card_title": "Switch to English?",
  "chat.learn_more": "Learn more",
  "chat.level_card_confirm": "Change",
  "chat.level_card_done": "Done — your knowledge level is now {level}.",
  "chat.level_card_title": "Change your knowledge level?",
  "chat.level_desc.advanced": "Precise terms, no basics",
  "chat.level_desc.beginner": "Everyday words and analogies",
  "chat.level_desc.intermediate": "Basics known, depth explained",
  "chat.level_desc.unset": "Each term explained the first time",
  "chat.log_out": "Log out",
  "chat.manage_sharing": "Manage sharing",
  "chat.mcp_card_copied": "Copied — paste it into your AI",
  "chat.mcp_card_copy": "Copy setup prompt",
  "chat.mcp_card_copy_hint": "Copies a prompt to paste into your AI, which sets the connection up for you",
  "chat.mcp_card_lead_asked": "Yes — gethumandesign works inside Claude, ChatGPT, Gemini and others.",
  "chat.mcp_card_lead_beyond_hd": "This app reads Human Design and nothing else. An assistant you connect can take the wider question, with your design alongside.",
  "chat.mcp_card_lead_files": "This chat can't open documents or images. Claude and ChatGPT can — with your design already there.",
  "chat.mcp_card_lead_memory": "Every chat here starts fresh. Connect an assistant and your design comes along instead.",
  "chat.mcp_card_point_account": "Same account, same saved people. Nothing to copy across.",
  "chat.mcp_card_point_files": "Bring in documents and images — tune a CV, a job description or a plan against your design.",
  "chat.mcp_card_point_memory": "It remembers between chats, so your design stays context conversation after conversation.",
  "chat.mcp_card_title": "Use your design in the AI you already use",
  "chat.me_badge": "me",
  "chat.mention.add_person": "Add someone",
  "chat.mention.ambiguous": "which one?",
  "chat.mention.ambiguous_hint": "More than one person is saved under this name. Remove it and pick from the list.",
  "chat.mention.blocked_attached": "Already in this message",
  "chat.mention.blocked_chat_groups": "This chat already follows all the groups it can. Start a new chat for another one.",
  "chat.mention.blocked_chat_pair": "This chat is already comparing two people. Start a new chat to read a group.",
  "chat.mention.blocked_chat_people": "This chat already follows all the people it can. Start a new chat for someone else.",
  "chat.mention.blocked_message_groups": "This message already names as many groups as it can. Remove one to name another.",
  "chat.mention.blocked_message_people": "This message already names as many people as it can. Remove one to name someone else.",
  "chat.mention.chips_label": "Mentioned in this message",
  "chat.mention.empty": "Nobody saved by that name",
  "chat.mention.groups": "Groups",
  "chat.mention.label": "People and groups you can mention",
  "chat.mention.loading": "Looking up your people…",
  "chat.mention.members": "{count} people",
  "chat.mention.people": "People",
  "chat.mention.pro_offer": "Ask about a whole group",
  "chat.mention.remove": "Remove {name}",
  "chat.mention.sheet_title": "Who do you mean?",
  "chat.menu": "Menu",
  "chat.menu_rename": "Rename",
  "chat.menu_share": "Share",
  "chat.new_chat": "New chat",
  "chat.no_conversations": "No conversations yet",
  "chat.pdf_role_you": "You",
  "chat.people_groups": "People & Groups",
  "chat.placeholder": "Ask gethumandesign",
  "chat.placeholder_private": "Ask privately about your Human Design...",
  "chat.plan_free": "Free",
  "chat.plan_pro": "Pro",
  "chat.private_chat": "Private chat",
  "chat.private_notice": "Private chat — your messages won't be saved or appear in your chat history.",
  "chat.quota_contact_pro": "This cap only exists to stop abuse — email {email} and we'll lift it.",
  "chat.quota_limit_reached": "Message limit reached.",
  "chat.quota_placeholder_free": "Message limit reached. Upgrade to Pro or wait for the limit to reset.",
  "chat.quota_placeholder_pro": "Message limit reached. Email hello@gethumandesign.com and we'll lift it.",
  "chat.reading_the_sky": "Reading the sky...",
  "chat.recent": "Recent",
  "chat.reply_cut_off": "This reply was cut off.",
  "chat.reply_ready": "Reply ready",
  "chat.report_intro": "What is wrong with this answer? We read every report and use it to improve the AI's replies.",
  "chat.report_note_placeholder": "Anything else we should know? (optional)",
  "chat.report_reason_harmful": "Harmful or dangerous",
  "chat.report_reason_inaccurate": "Wrong or misleading",
  "chat.report_reason_offensive": "Offensive or hateful",
  "chat.report_reason_other": "Something else",
  "chat.report_reply": "Report this reply",
  "chat.report_send": "Send report",
  "chat.report_sent_body": "We will review this reply.",
  "chat.report_sent_title": "Report sent — thank you",
  "chat.report_title": "Report this reply",
  "chat.save": "Save",
  "chat.scroll_to_bottom": "Scroll to bottom",
  "chat.seed_explain_my_design": "Please explain my bodygraph in simple, beginner-friendly terms.",
  "chat.seed_person_named": "Explain {name}'s Bodygraph and focus on their type, authority, profile, centers, channels, and practical guidance.",
  "chat.seed_person_self": "Explain my Bodygraph and focus on my type, authority, profile, centers, channels, and practical guidance.",
  "chat.seed_temp_full": "Calculate and explain the Bodygraph for {name} using birth datetime {datetime} and birth place {place}. Focus on type, authority, profile, centers, channels, and practical guidance.",
  "chat.seed_temp_topic": "Using birth datetime {datetime} and birth place {place}, calculate the Bodygraph for {name} and explain this part of it: {topic}",
  "chat.send": "Send",
  "chat.sending": "Sending...",
  "chat.settings": "Settings",
  "chat.share_conversation": "Share conversation",
  "chat.share_default_title": "Human Design conversation",
  "chat.share_desc": "Anyone with the link can view it.",
  "chat.share_this_conversation": "Share this conversation",
  "chat.something_went_wrong": "Something went wrong",
  "chat.stability_card_born": "Born {date}",
  "chat.stability_card_explore": "Explore the full day",
  "chat.stability_card_hint": "Drag the line, or click a time for details.",
  "chat.stability_card_nudge": "Know the exact time? Updating it sharpens everything at once.",
  "chat.stability_card_nudge_exact": "See the same day gate by gate.",
  "chat.stability_card_time_on_file": "time on file {time}",
  "chat.stability_card_title": "Birth-time stability check",
  "chat.stability_card_title_exact": "What changes with birth hour",
  "chat.stability_card_update": "Update birth time",
  "chat.stability_card_window_day": "checked across the whole birth day",
  "chat.stability_card_window_span": "checked {from}–{to}",
  "chat.stability_off_activated": "not activated",
  "chat.stability_off_defined": "not defined",
  "chat.stability_off_undefined": "undefined",
  "chat.stability_on_activated": "activated",
  "chat.stability_on_defined": "defined",
  "chat.stability_precision_channel": "{gateA}–{gateB}",
  "chat.stability_precision_counts": "{gates} gates · {channels} channels · {centers} centers",
  "chat.stability_precision_defined": "Defined",
  "chat.stability_precision_gate": "Gate {gate}",
  "chat.stability_precision_note": "Measured every {minutes} minutes across the birth day.",
  "chat.stability_precision_nudge": "Explore every layer, then update the time when you know more.",
  "chat.stability_precision_nudge_exact": "Every gate, channel and center, hour by hour.",
  "chat.stability_precision_open": "Open full explorer",
  "chat.stability_precision_title": "Activation-level precision",
  "chat.stability_precision_undefined": "Undefined",
  "chat.starter_auth_ego": "How do I know what I truly want?",
  "chat.starter_auth_emotional": "Should I sleep on this decision?",
  "chat.starter_auth_mental": "Where do I decide best?",
  "chat.starter_auth_sacral": "How do I trust my gut response?",
  "chat.starter_auth_self_projected": "Why talk my decisions out loud?",
  "chat.starter_auth_splenic": "How do I catch my intuition?",
  "chat.starter_burnt_out": "Why do I get burnt out?",
  "chat.starter_cross": "What's my incarnation cross?",
  "chat.starter_decisions": "How do I make decisions well?",
  "chat.starter_environment": "What environment helps me?",
  "chat.starter_explain": "Explain my Human Design",
  "chat.starter_hd_basics": "Explain the basics of Human Design",
  "chat.starter_learn": "What am I here to learn?",
  "chat.starter_on_track": "How do I know I'm on track?",
  "chat.starter_open_centers": "What do my open centers teach me?",
  "chat.starter_overextend": "Where do I overextend?",
  "chat.starter_partner": "What works well between me and my partner?",
  "chat.starter_profile": "What does my profile mean?",
  "chat.starter_sit_boundary": "Help me set a boundary",
  "chat.starter_sit_decision": "Help me make a tough decision",
  "chat.starter_sit_exhausted": "Why am I so exhausted today?",
  "chat.starter_sit_hard_talk": "Prep me for a hard conversation",
  "chat.starter_sit_interview": "Prep me for a job interview",
  "chat.starter_sit_recharge": "How should I recharge tonight?",
  "chat.starter_sit_right_job": "Am I in the right job?",
  "chat.starter_sit_stuck": "Why do I feel stuck right now?",
  "chat.starter_strategy": "What's my Strategy?",
  "chat.starter_strengths": "What are my strengths?",
  "chat.starter_success": "What does success mean for me?",
  "chat.starter_thrive_generator": "How do I thrive as a Generator?",
  "chat.starter_thrive_manifestor": "How do I thrive as a Manifestor?",
  "chat.starter_thrive_mg": "How do I thrive as an MG?",
  "chat.starter_thrive_projector": "How do I thrive as a Projector?",
  "chat.starter_thrive_reflector": "How do I thrive as a Reflector?",
  "chat.starter_unique": "What makes my design unique?",
  "chat.starter_walk_chart": "Walk me through my bodygraph",
  "chat.starter_who_am_i": "Who am I at my core?",
  "chat.status_analyse_group": "Analysing the group…",
  "chat.status_analyse_group_named": "Analysing {name}…",
  "chat.status_birth_time_named": "Saving {name}'s birth time…",
  "chat.status_birth_time_self": "Saving your birth time…",
  "chat.status_connection": "Reading the connection…",
  "chat.status_connection_named": "Reading the connection between {a} and {b}…",
  "chat.status_feedback": "Sending your feedback…",
  "chat.status_find_people": "Searching your people…",
  "chat.status_generic": "Working on it…",
  "chat.status_list_groups": "Looking through your groups…",
  "chat.status_list_people": "Looking through your people…",
  "chat.status_mcp": "Getting the connection details…",
  "chat.status_new_bodygraph": "Calculating a new bodygraph…",
  "chat.status_person_design": "Reading the bodygraph…",
  "chat.status_person_design_named": "Reading {name}'s bodygraph…",
  "chat.status_person_design_self": "Reading your bodygraph…",
  "chat.status_pro": "Getting the Pro details…",
  "chat.status_read_skill": "Checking our own material…",
  "chat.status_save_group": "Saving the group {name}…",
  "chat.status_save_person": "Saving the new person…",
  "chat.status_save_person_named": "Saving {name}…",
  "chat.status_show_named": "Bringing up {name}'s bodygraph…",
  "chat.status_show_self": "Bringing up your bodygraph…",
  "chat.status_stability_named": "Checking {name}'s birth day, hour by hour…",
  "chat.status_stability_self": "Checking your birth day, hour by hour…",
  "chat.status_try_times_named": "Trying those times on {name}'s bodygraph…",
  "chat.status_try_times_self": "Trying those times on your bodygraph…",
  "chat.status_update_person": "Updating the details…",
  "chat.status_update_person_named": "Updating {name}…",
  "chat.status_update_person_self": "Updating your details…",
  "chat.status_you": "you",
  "chat.stop_generating": "Stop generating",
  "chat.subject_this_person": "this person",
  "chat.suggested_questions": "Suggested questions",
  "chat.switching_language": "Preparing the language switch…",
  "chat.tip_new_chat": "New chat (⇧{mod}+O)",
  "chat.tip_people_groups": "People & Groups",
  "chat.tip_search_chats": "Search chats ({mod}+K)",
  "chat.tip_settings": "Settings",
  "chat.tip_sidebar": "Sidebar ({mod}+.)",
  "chat.tip_transits": "Transits",
  "chat.toggle_sidebar": "Toggle sidebar",
  "chat.topic_adv_angle": "The angle of the Incarnation Cross — Right Angle, Juxtaposition or Left Angle — and what kind of trajectory that describes for this life.",
  "chat.topic_adv_calculation": "How this chart was calculated — the time zone and offset applied to the birth time, the birth moment in UTC, and the Design moment 88° of solar arc before birth.",
  "chat.topic_adv_cognition": "Cognition — the strongest sense, the \"super sense\" this design takes the world in through, and how to lean on it when taking in information.",
  "chat.topic_adv_determination": "Determination, the digestion arrow of Variable (part of the PHS) — what this determination means for how the body takes in food and information, and what it looks like day to day.",
  "chat.topic_adv_distraction": "Distraction — the substitute Perspective the mind looks through when it is off-track, how it differs from the true View, and how to recognise it.",
  "chat.topic_adv_dreamrave": "DreamRave — the sleep chart: the type this design has at night, and which of the five centers that stay online in sleep are open.",
  "chat.topic_adv_environment": "Environment — the kind of space this body does best in, and what that looks like in practice at home and at work.",
  "chat.topic_adv_fixing": "Fixing — where the planets sit exalted, in detriment or juxtaposed, and what that says about how those energies express themselves.",
  "chat.topic_adv_gate": "Gates — what one of the 64 gates is, the I Ching hexagram behind it, and what a gate contributes to a chart.",
  "chat.topic_adv_godhead": "The Face of the Godhead this cross falls under: which four gates of its quarter it names, and what it says about the purpose the cross serves.",
  "chat.topic_adv_line": "The six lines in a gate — why one gate comes in six flavors, and what the line of an activation says about how that gate is lived.",
  "chat.topic_adv_motivation": "Motivation — the underlying frequency driving the mind, and how it colors what gets said and shared with others.",
  "chat.topic_adv_overlay": "Lilith and Chiron in this chart — what these two astrology points are usually taken to mean, and how they sit alongside (not inside) Human Design.",
  "chat.topic_adv_perspective": "Perspective — how the mind naturally sees the world, and what it is here to look at.",
  "chat.topic_adv_quarter": "The quarter of the Rave Mandala this cross falls in, the theme of that quarter, and how the purpose of the cross is fulfilled through it.",
  "chat.topic_adv_substructure": "Substructure — the color, tone and base sitting beneath the gate and line, and what each of those layers adds to a gate's meaning.",
  "chat.topic_adv_transference": "Transference — the substitute Motivation the mind slips into when it is conditioned and off-track, how it differs from the true Motivation, and how to recognise it.",
  "chat.topic_adv_wheel": "The Rave Mandala — the 360° wheel a chart is read off, how the 64 gates are laid around the zodiac, and how a planet's degree becomes a gate and a line.",
  "chat.topic_authority": "Authority — how it works, what to listen for, and how to use it for aligned decisions day-to-day.",
  "chat.topic_bridging_gates": "Bridging gates — which gates would join the separate areas of this definition, and what it feels like when someone carries one.",
  "chat.topic_center_defined": "The {center} center, defined — what this center governs, what steady access to that energy means, and how it shows up in life.",
  "chat.topic_center_undefined": "The {center} center, undefined — what this center governs, what being open there means, the conditioning to watch for, and the wisdom it can become.",
  "chat.topic_channel": "Channel {a}–{b} — the two gates, the dynamic between them, and how it shows up in life.",
  "chat.topic_cross": "Incarnation Cross — its theme, the gates involved, and how it expresses in life and purpose.",
  "chat.topic_definition": "Definition — what it means for how energy flows and how to connect with others.",
  "chat.topic_gate": "Gate {gate} — what it represents, its theme, and how it shows up in life.",
  "chat.topic_not_self": "Not-Self theme — what triggers it, how to notice it early, and how to come back into alignment.",
  "chat.topic_planet": "{planet} — what this point represents, and how its Design (unconscious) and Personality (conscious) gates and lines shape the Bodygraph.",
  "chat.topic_profile": "Profile — both lines, the life themes they bring, and how they typically show up in relationships and work.",
  "chat.topic_prompt_other": "Explain this part of this person's Human Design: {topic}",
  "chat.topic_prompt_person": "Explain this part of {name}'s Human Design: {topic}",
  "chat.topic_prompt_self": "Explain this part of my Human Design: {topic}",
  "chat.topic_signature": "Signature — what it feels like when living in alignment and how to recognize it.",
  "chat.topic_strategy": "Strategy — how to apply it in everyday situations and what alignment feels like.",
  "chat.topic_type": "Type — what it means for how to operate, the signature and not-self, and how decisions get made.",
  "chat.transits": "Transits",
  "chat.upgrade_card_done": "You're on Pro",
  "chat.upgrade_summary": "Unlimited charts and chat, our deepest AI readings, transits and cycles, Penta group analysis and every advanced layer of your chart.",
  "chat.upgrade_to_pro": "Upgrade to Pro",
  "chat.usage_messages": "{used}/{limit} messages",
  "chat.wait_composing": "Putting it together…",
  "chat.wait_long": "This reply is taking a bit longer than usual — still working.",
  "chat.wait_long_saved": "Your message is saved — this reply is taking a bit longer than usual.",
  "chat.wait_very_long": "Still working. Longer answers can take up to a minute.",
  "chat.wait_working": "Working on your reply…",
  "chat.what_call_you": "What should I call you?",
  "chat.your_name": "Your name",
  "chats.delete_button": "Delete",
  "chats.delete_confirm": "Delete {title}?",
  "chats.delete_failed": "Couldn't delete the conversation. Please try again.",
  "chats.delete_keeps": "Your saved people and their bodygraphs stay saved. Every chat starts fresh, so a new one never remembers this one.",
  "chats.delete_shared": "The share link for this conversation will stop working.",
  "chats.delete_sub": "This conversation will be permanently deleted.",
  "chats.empty_cta": "Start your first conversation to explore your Human Design.",
  "chats.group_earlier": "Earlier",
  "chats.group_today": "Today",
  "chats.group_week": "This week",
  "chats.group_yesterday": "Yesterday",
  "chats.menu_download_pdf": "Download PDF",
  "chats.more_actions": "More actions for {title}",
  "chats.more_matches": "+{count} more matches",
  "chats.more_matches_one": "+1 more match",
  "chats.more_results": "Showing the 30 most recent chats that match. Add a word to narrow it down.",
  "chats.no_match": "No chats or messages match your search.",
  "chats.pdf_failed": "The PDF could not be made. Please try again in a moment.",
  "chats.pdf_ready_dismiss": "Not now",
  "chats.pdf_ready_save": "Save PDF",
  "chats.pdf_ready_title": "Your PDF is ready",
  "chats.rename_failed": "Couldn't rename the conversation. Please try again.",
  "chats.rename_title": "Rename conversation",
  "chats.search_label": "Search chats",
  "chats.search_placeholder": "Search your chats…",
  "chats.searching_messages": "Searching your messages…",
  "chats.snippet_you": "You:",
  "chats.time_just_now": "Just now",
  "chats.title": "Chats",
  "common.timezone": "Timezone: {timezone}",
  "compare.action": "Compare",
  "compare.action_with": "Compare with…",
  "compare.add_pair": "Add pair",
  "compare.aria_chart": "Composite bodygraph for {a} and {b}",
  "compare.aria_chart_person": "Bodygraph for {name}",
  "compare.bridge_bridged": "{other}'s gate {gate} bridges {name}'s split ({channel})",
  "compare.bridge_open": "{name}'s split stays open here — gate {gates} would bridge it, and neither of you carries one",
  "compare.chat_prompt": "What does the connection between {a} and {b} look like?",
  "compare.choose": "Choose two people",
  "compare.cta": "Ask AI about this connection",
  "compare.download_pdf": "Download connection PDF",
  "compare.empty_sub": "Every channel is colored by who brings it. Every pair you open stays here until you remove it.",
  "compare.empty_title": "See two people as one chart",
  "compare.error_not_found": "One of these people isn't in your saved list. Choose two saved people to compare.",
  "compare.error_same": "Pick two different people to compare.",
  "compare.estimated_time_note": "{name}'s birth time isn't pinned down, so this bodygraph rests on an estimate.",
  "compare.header": "Connection",
  "compare.hint_clash": "Where will {a} and {b} clash?",
  "compare.hint_conflict": "Help {a} and {b} settle a conflict",
  "compare.hint_needs": "What does {a} need from {b}?",
  "compare.hint_pair": "How do {a} and {b} work together?",
  "compare.hint_sky_pair": "What is today's sky doing to {a} and {b}?",
  "compare.hint_sky_pair_me": "What is today's sky doing to {name} and me?",
  "compare.hint_sky_through": "Which channels does today's sky complete through {name}'s gates?",
  "compare.hint_sky_weather": "How can {a} and {b} tell today's transits apart from their connection?",
  "compare.hint_sky_weather_me": "How can {name} and I tell today's transits apart from our connection?",
  "compare.ix_only": "only {name}",
  "compare.kb_q": "What does {subject} mean for the connection between {a} and {b}?",
  "compare.legend_both": "Both of you",
  "compare.legend_likely": "Likely",
  "compare.legend_together": "Defined only together",
  "compare.legend_window_note": "A birth time here isn't exact, so the chart shows what holds at every minute it could be. Grey holds for most of them; open shapes depend on the exact time.",
  "compare.load_failed": "Could not load this comparison. Please try again in a moment.",
  "compare.new_pair_title": "New pair",
  "compare.or": "or",
  "compare.pair_channel": "{count} channel",
  "compare.pair_channels": "{count} channels",
  "compare.pair_channels_none": "No channels",
  "compare.pair_time_note_both": "This connection is read from approximate birth times for {a} and {b}. A different hour can add or remove channels.",
  "compare.pair_time_note_cta": "Narrow the time",
  "compare.pair_time_note_one": "This connection is read from an approximate birth time for {name}. A different hour can add or remove channels.",
  "compare.pdf_failed": "Could not create the PDF. Please try again.",
  "compare.pdf_time_note_both": "{a} and {b} both have an approximate birth time, and this connection is read from them. Values the hour does not settle are left out of this page.",
  "compare.pdf_time_note_one": "{name}'s birth time is approximate, and this connection is read from it. Values the hour does not settle are left out of this page.",
  "compare.picker_empty": "You need at least two saved people to compare. Add someone first.",
  "compare.preparing_pdf": "Preparing PDF…",
  "compare.profile_conscious": "Conscious",
  "compare.profile_unconscious": "Unconscious",
  "compare.rel_dissonance": "Dissonance",
  "compare.rel_harmony": "Harmony",
  "compare.rel_resonance": "Resonance",
  "compare.remove_pair": "Remove pair",
  "compare.remove_pair_confirm": "Remove {a} × {b} from your pairs? Both people stay saved.",
  "compare.remove_pair_named": "Remove {a} × {b}",
  "compare.section_bridges": "Split bridges",
  "compare.section_channels": "Channels between you",
  "compare.section_profiles": "Profile lines",
  "compare.sky_background_many": "Everyone: the sky forms {n} channels on its own, in every chart.",
  "compare.sky_background_one": "Everyone: the sky forms {n} channel on its own, in every chart.",
  "compare.sky_centers": "Centers the sky lights for you: {centers}.",
  "compare.sky_frame": "Transits are weather, not the relationship: each of you feels them through your own open centers, and decisions stay with each person's own authority.",
  "compare.sky_list_both": "For both of you",
  "compare.sky_list_both_sub": "The sky completes a channel through a gate you both hold.",
  "compare.sky_list_connection": "Your connection, lit",
  "compare.sky_list_connection_sub": "A planet lands on a channel the two of you already form.",
  "compare.sky_list_person": "For {name}",
  "compare.sky_list_person_sub": "The sky completes a channel through one of {name}'s gates.",
  "compare.sky_quiet": "At this moment the sky completes nothing new in these two charts.",
  "compare.sky_stands_in": "The sky carries gate {gate}, which {name} usually brings.",
  "compare.slot_a": "Person 1",
  "compare.slot_b": "Person 2",
  "compare.slot_clear": "Clear {name}",
  "compare.slot_empty": "Tap to choose",
  "compare.stage_arrow_hint": "to move between views",
  "compare.stage_show_both": "Both bodygraphs",
  "compare.sub_companionship": "you both carry the whole channel — shared ground",
  "compare.sub_compromise": "one whole, one half — friction to negotiate",
  "compare.sub_dominance": "one of you carries it whole — a one-way imprint",
  "compare.sub_electromagnetic": "each of you brings one gate — the spark",
  "compare.together": "Together",
  "compare.transits_at": "The sky at {when}",
  "compare.transits_locked": "The sky over this pair is part of Pro.",
  "compare.transits_needs_time_both": "Transits need {a}'s and {b}'s exact birth times",
  "compare.transits_needs_time_one": "Transits need {name}'s exact birth time",
  "compare.transits_needs_time_sub": "The sky crosses a gate in hours, so without both exact times we can't say what it meets in these two charts.",
  "compare.transits_set_time": "Set {name}'s birth time",
  "compare.view_side_by_side": "Side by side",
  "compare.view_transits": "Transits",
  "compare.view_transits_pro": "Transits, part of Pro",
  "compare.views_label": "Which bodygraph to show",
  "consent.allow": "Allow",
  "consent.already_setup_body": "Birth details were already saved for this account, so we left them alone. Replace them with what you just entered?",
  "consent.already_setup_keep": "Keep the saved ones",
  "consent.already_setup_replace": "Use my new details",
  "consent.already_setup_title": "This account already has a Bodygraph",
  "consent.auth_continue_with": "Continue with {provider}",
  "consent.auth_create_body": "An app is asking to connect to a Human Design account.",
  "consent.auth_create_body_named": "{app} is asking to connect to a Human Design account.",
  "consent.auth_create_submit": "Create account",
  "consent.auth_create_title": "Create your account",
  "consent.auth_creating": "Creating your account…",
  "consent.auth_email_taken": "That email already has an account. Sign in and you will be connected.",
  "consent.auth_mode_create": "Create account",
  "consent.auth_mode_label": "Create an account or sign in",
  "consent.auth_mode_signin": "Sign in",
  "consent.auth_or_email": "or",
  "consent.auth_password_hint": "At least 8 characters",
  "consent.auth_signin_body": "An app is asking to connect to your Human Design account.",
  "consent.auth_signin_body_named": "{app} is asking to connect to your Human Design account.",
  "consent.auth_signin_title": "Sign in to connect",
  "consent.authorizing": "Authorizing…",
  "consent.client_generic": "An app",
  "consent.client_quoted": "“{name}”",
  "consent.confidence_exact": "Exact",
  "consent.confidence_label": "How sure are you of the time?",
  "consent.confidence_roughly": "Roughly",
  "consent.confidence_unknown": "Unsure",
  "consent.confirm_body": "We sent a confirmation link to {email}. Open it to finish creating your account.",
  "consent.confirm_next": "Then go back to the app you were connecting from and start the connection again.",
  "consent.confirm_title": "Confirm your email",
  "consent.deny": "Deny",
  "consent.denying": "Denying…",
  "consent.destination_line": "After you choose, you go to {destination}.",
  "consent.destination_local": "an app on this device",
  "consent.destination_mismatch": "This app's name says {brand}, but it doesn't lead to {brand}. If you meant to connect {brand}, choose Deny and start again from {brand} itself.",
  "consent.destination_scheme": "an app on this device that opens {scheme} links",
  "consent.destination_unknown": "We don't recognise this app. Allow it only if you started this connection yourself.",
  "consent.done_ask_lead": "Explore your Human Design with AI",
  "consent.done_back": "Back to {app}",
  "consent.done_back_generic": "Back to your assistant",
  "consent.done_copied": "Copied",
  "consent.done_copy": "Copy",
  "consent.done_time_roughly": "{time}, roughly",
  "consent.done_time_unknown": "birth time unknown",
  "consent.done_title": "All set, {name}",
  "consent.done_title_typed": "All set. You're a {type}, {name}",
  "consent.error.generic": "Something went wrong. Please try again.",
  "consent.error.missing_fields": "Please fill in your first name, birth date, birth time and birth place.",
  "consent.error.save_failed": "Could not save your details. Please try again.",
  "consent.expired_reconnect": "Start the connection again from your assistant — nothing was lost.",
  "consent.handoff_body": "Your browser should now ask to open the app. Once the app has opened, you can close this tab.",
  "consent.in_app_body": "This screen opened in the Human Design app instead of your browser, so we cannot hand you back automatically. Your approval is saved.",
  "consent.in_app_continue": "Try continuing here",
  "consent.in_app_denied_body": "This screen opened in the Human Design app instead of your browser. Nothing was connected, and no access was given.",
  "consent.in_app_denied_next": "You can close this screen. The app you were connecting from was not given access.",
  "consent.in_app_denied_title": "Connection refused",
  "consent.in_app_retry": "Go back to the app you were connecting from and start the connection again — it will go straight through.",
  "consent.in_app_title": "Almost there",
  "consent.intro": "{app} wants to connect to your Human Design account. It will be able to read and save the people in your account, calculate charts, and send your feedback to us. It cannot change your subscription or delete your account.",
  "consent.language": "Language",
  "consent.loading": "Loading…",
  "consent.loading_details": "Loading authorization details…",
  "consent.name_mixed_script": "Its name mixes letters from different alphabets, which can make it look like another app. Allow it only if you know it.",
  "consent.not_you": "Not you? Sign out and start again",
  "consent.setup_connected_body": "{app} can reach your account now. Add your birth details and it can read your Bodygraph straight away.",
  "consent.setup_connected_title": "You're connected",
  "consent.setup_later": "Not now",
  "consent.setup_later_note": "Either way you go back to your assistant — if you skip this, it can ask you instead.",
  "consent.setup_place_skip": "Or connect now and let your assistant ask you for it",
  "consent.setup_save": "Save",
  "consent.signed_in_as": "Signed in as {email}",
  "consent.signing_in": "Signing in…",
  "consent.title": "Authorize access",
  "consent.tos_line": "By continuing you agree to the {terms} and {privacy}.",
  "consent.unavailable_title": "We couldn't finish this connection",
  "consent.unknown_time_hint": "No problem — 12:00 noon is used and the uncertainty is noted on your chart.",
  "currency.empty": "No currency found",
  "currency.header": "Show price in",
  "currency.search": "Search currency",
  "cycles.about_kiron_return": "Kiron (Chiron, as astrology spells it) back where it stood at birth, around age 50. Ra called it coming off the roof: the long stretch of building ends, and what is truly yours comes forward.",
  "cycles.about_nodal_return": "The Nodes back where they stood at birth, about every 18.6 years. The direction of a life comes round again for a while. A smaller cycle, not one of the three stages of Ra's Cycle Analysis.",
  "cycles.about_saturn_return": "Saturn back where it stood at birth, about every 29 years. A phase of maturing that begins and ends. The second, around 58, is the harvest: handing responsibility on and living what has held, with nothing left to prove.",
  "cycles.about_solar_return": "The Sun back at its birth position. Its Bodygraph colours the year ahead; the Incarnation Cross stays the one from birth.",
  "cycles.about_uranus_opposition": "Uranus halfway round from where it stood at birth, around age 40. A mid-life turn: a phase that begins and ends.",
  "cycles.against_quiet": "This {cycle} adds no channels or centers to your Bodygraph. It mostly echoes what is already there.",
  "cycles.against_quiet_named": "This {cycle} adds no channels or centers to {name}'s Bodygraph. It mostly echoes what is already there.",
  "cycles.against_title": "Against your Bodygraph",
  "cycles.against_title_named": "Against {name}'s Bodygraph",
  "cycles.age": "age {age}",
  "cycles.age_about": "about age {age}",
  "cycles.aria_chart": "{cycle} Bodygraph, drawn over {name}'s own",
  "cycles.ask_meaning": "What does my {cycle} of {year} mean for me?",
  "cycles.ask_meaning_named": "What does the {cycle} of {year} mean for {name}?",
  "cycles.ask_natal": "How does my {cycle} of {year} meet my own Bodygraph?",
  "cycles.ask_natal_named": "How does the {cycle} of {year} meet {name}'s own Bodygraph?",
  "cycles.ask_window": "How can I make good use of my {cycle} window in {year}?",
  "cycles.ask_window_named": "How can {name} make good use of the {cycle} window in {year}?",
  "cycles.axis_caption": "Age",
  "cycles.center_alone": "by the cycle",
  "cycles.center_together": "together",
  "cycles.chart_error_title": "The cycle chart didn't load",
  "cycles.chart_unavailable_sub": "It falls outside the years our planetary tables cover. Please pick another return.",
  "cycles.chart_unavailable_title": "This return can't be charted",
  "cycles.choose_prompt": "Tap a return on the timeline, or a year, to see its Bodygraph read against your own.",
  "cycles.choose_prompt_named": "Tap a return on the timeline, or a year, to see its Bodygraph read against {name}'s.",
  "cycles.crumbs_label": "Breadcrumb",
  "cycles.error_sub": "Please try again in a moment. If it keeps happening, email hello@gethumandesign.com and we'll look into it.",
  "cycles.error_title": "The cycles didn't load",
  "cycles.explain_amplified": "A channel you were born with, repeated by the cycle. Nothing is added; what is already yours is louder.",
  "cycles.explain_amplified_named": "A channel {name} was born with, repeated by the cycle. Nothing is added; what is already theirs is louder.",
  "cycles.explain_background": "The cycle holds both ends. It is the climate of this stage, not something added to you.",
  "cycles.explain_background_named": "The cycle holds both ends. It is the climate of this stage, not something added to {name}.",
  "cycles.explain_direct": "The cycle holds the gate you are missing, and the channel closes. This is what can activate an open center for this stage.",
  "cycles.explain_direct_named": "The cycle holds the gate {name} is missing, and the channel closes. This is what can activate an open center for this stage.",
  "cycles.fact_adds": "Adds",
  "cycles.fact_environment": "Environment",
  "cycles.fact_environment_sub": "The Nodes: the setting and direction of this stage.",
  "cycles.fact_role": "Role",
  "cycles.fact_role_sub": "The Profile this theme is lived through.",
  "cycles.fact_theme": "Theme",
  "cycles.fact_theme_sub": "The Incarnation Cross of this stage.",
  "cycles.fixed_note": "Type, Strategy and Authority stay your own; a cycle never changes them.",
  "cycles.fixed_note_named": "Type, Strategy and Authority stay {name}'s own; a cycle never changes them.",
  "cycles.kb_q_environment": "In my {cycle} of {year} the North Node stands in {nodes}. What setting and direction does that give this stage for me?",
  "cycles.kb_q_environment_named": "In the {cycle} of {year} the North Node stands in {nodes}. What setting and direction does that give this stage for {name}?",
  "cycles.kb_q_role": "My {cycle} of {year} is lived through Profile {profile}. What does that mean for me?",
  "cycles.kb_q_role_named": "The {cycle} of {year} is lived through Profile {profile}. What does that mean for {name}?",
  "cycles.kb_q_theme": "My {cycle} of {year} has the {cross} as its theme. What does that mean for me?",
  "cycles.kb_q_theme_named": "The {cycle} of {year} has the {cross} as its theme. What does that mean for {name}?",
  "cycles.kb_q_window": "My {cycle} of {year} falls in Gate {gate}, line {line}. What does that gate mean for me in this stage?",
  "cycles.kb_q_window_named": "The {cycle} of {year} falls in Gate {gate}, line {line}. What does that gate mean for {name} in this stage?",
  "cycles.kb_subject_environment": "this stage's environment",
  "cycles.kb_subject_moment": "this cycle",
  "cycles.kb_subject_role": "this stage's role",
  "cycles.kb_subject_theme": "this stage's theme",
  "cycles.kb_subject_window": "Gate {gate} in this cycle",
  "cycles.lede": "A return is when a slow planet comes back to where it stood at birth. Each one opens a new stage of life.",
  "cycles.lede_detail": "Saturn returns about every 29 years, Uranus reaches the opposite spot around 42, and Kiron (Chiron) returns once, around 50: the three stages of Ra's Cycle Analysis. The Nodes return every 18.6 years, a smaller cycle shown apart. Pick a return to see the chart of that exact moment, read against the Bodygraph.",
  "cycles.lede_more": "How returns work",
  "cycles.legend_both": "Both",
  "cycles.legend_together": "Activated only together",
  "cycles.loading_chart": "Casting the cycle chart…",
  "cycles.locked_sub": "See when Saturn, Uranus, Kiron and the Nodes come back round in a life, and read each return's Bodygraph against your own.",
  "cycles.locked_title": "Cycles and returns are part of Pro",
  "cycles.minor_caption": "Also calculated, and not one of the three stages of Ra's Cycle Analysis",
  "cycles.moment": "Moment",
  "cycles.name_kiron_return": "Kiron return",
  "cycles.name_nodal_return": "Nodal return",
  "cycles.name_nodal_return_1": "First Nodal return",
  "cycles.name_nodal_return_2": "Second Nodal return",
  "cycles.name_nodal_return_3": "Third Nodal return",
  "cycles.name_nodal_return_4": "Fourth Nodal return",
  "cycles.name_nth": "{name} {n}",
  "cycles.name_saturn_return": "Saturn return",
  "cycles.name_saturn_return_1": "First Saturn return",
  "cycles.name_saturn_return_2": "Second Saturn return",
  "cycles.name_saturn_return_3": "Third Saturn return",
  "cycles.name_solar_return": "Solar return",
  "cycles.name_uranus_opposition": "Uranus opposition",
  "cycles.needs_time_sub": "The timeline works without it, but a cycle chart's Moon and Design side follow the minute of birth.",
  "cycles.needs_time_title": "Set {name}'s exact birth time to open this chart",
  "cycles.no_people_sub": "Cycles are read against a Bodygraph, so there has to be one to read them against.",
  "cycles.no_people_title": "No one saved yet",
  "cycles.no_precise_data": "We don't have precise data for this return yet.",
  "cycles.none_on_timeline": "No returns fall before age 90 in the years we can calculate.",
  "cycles.not_found_action": "Go to People",
  "cycles.not_found_sub": "They may have been removed. Please pick someone from your people.",
  "cycles.not_found_title": "We couldn't find this person",
  "cycles.pass_n": "Pass {n}",
  "cycles.passes_label": "Passes",
  "cycles.passes_n": "{n} passes",
  "cycles.pick_person_title": "Show the cycles of",
  "cycles.retrograde": "retrograde",
  "cycles.row_defines": "{center} activated · {channel}",
  "cycles.sec_centers": "Open centers the {cycle} activates",
  "cycles.sec_centers_sub": "Still open in your Bodygraph; conditioned by this stage.",
  "cycles.sec_centers_sub_named": "Still open in {name}'s Bodygraph; conditioned by this stage.",
  "cycles.sixth_line_kiron_return": "Your Profile {profile} has a 6th line: this return is where it comes off the roof and its third phase, the Role Model, begins.",
  "cycles.sixth_line_kiron_return_named": "{name}'s Profile {profile} has a 6th line: this return is where it comes off the roof and its third phase, the Role Model, begins.",
  "cycles.sixth_line_saturn_return": "Your Profile {profile} has a 6th line: this return is where its roof years begin, the second of its three phases.",
  "cycles.sixth_line_saturn_return_named": "{name}'s Profile {profile} has a 6th line: this return is where its roof years begin, the second of its three phases.",
  "cycles.solar_lane_name": "Solar return · every year",
  "cycles.solar_same_note": "A Solar return keeps your own Cross and Profile; the year shows in the planets and Nodes.",
  "cycles.solar_same_note_named": "A Solar return keeps {name}'s own Cross and Profile; the year shows in the planets and Nodes.",
  "cycles.solar_title": "Solar return {year}",
  "cycles.status_now": "Now",
  "cycles.status_past": "Past",
  "cycles.status_upcoming": "Ahead",
  "cycles.time_note": "The birth time isn't exact. The timeline still holds to a day or two, but the cycle charts need the exact time.",
  "cycles.timeline_label_to": "Lifetime timeline, from age 0 to {age}",
  "cycles.title": "Cycles and returns",
  "cycles.title_short": "Cycles",
  "cycles.window": "Window",
  "cycles.window_gate": "in gate {gate}, line {line}",
  "cycles.window_range": "{from} – {until}",
  "footer.android": "Android app",
  "footer.app_store_badge": "/assets/app-store-badge-en.svg",
  "footer.app_store_badge_alt": "Download on the App Store",
  "footer.col_legal": "Legal",
  "footer.col_product": "Product",
  "footer.compare": "Compare apps",
  "footer.contact": "Contact us",
  "footer.copyright": "&#169; 2026 gethumandesign.com · Vink Data en AI B.V.",
  "footer.delete_account": "Delete account",
  "footer.invite": "We'd love to hear from you. Reach out at <a href=\"&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#104;&#101;&#108;&#108;&#111;&#64;&#103;&#101;&#116;&#104;&#117;&#109;&#97;&#110;&#100;&#101;&#115;&#105;&#103;&#110;&#46;&#99;&#111;&#109;\">hel<span hidden>foo</span>lo@gethuman<span hidden>bar</span>design.com</a>",
  "footer.ios": "iPhone and iPad app",
  "footer.knowledge_base": "Knowledge Base",
  "footer.language": "Language",
  "footer.mcp": "MCP Server",
  "footer.play_badge": "/assets/google-play-badge-en.svg",
  "footer.play_badge_alt": "Get it on Google Play",
  "footer.privacy": "Privacy Policy",
  "footer.status": "Status",
  "footer.status_degraded": "Degraded performance",
  "footer.status_down": "Some systems are down",
  "footer.status_ok": "All systems operational",
  "footer.support": "Support",
  "footer.tagline": "A modern Human Design app, built from the ground up for AI. Explore how you're designed to live.",
  "footer.terms": "Terms of Service",
  "footer.theme_to_dark": "Switch to dark mode",
  "footer.theme_to_light": "Switch to light mode",
  "footer.theme_toggle": "Toggle dark / light mode",
  "group.pair_aria": "Compare {a} and {b}",
  "group.pairs_label": "Compare a pair",
  "kb.close": "Close",
  "kb.explain_caption": "Opens the AI chat",
  "kb.explain_chart": "Explain this for this bodygraph",
  "kb.explain_person": "Explain this for {name}",
  "kb.explain_self": "Explain this for my design",
  "kb.explain_subject_chart": "Explain {subject} for this bodygraph",
  "kb.explain_subject_person": "Explain {subject} for {name}",
  "kb.explain_subject_self": "Explain {subject} for me",
  "kb.loading": "Loading…",
  "kb.open_full": "Open full page",
  "kb.subject_center": "the {center} center",
  "kb.subject_channel": "Channel {a}–{b}",
  "kb.subject_gate": "Gate {gate}",
  "kb.subject_substructure": "Color · Tone · Base",
  "kb.title": "Knowledge base",
  "lang.empty": "No language found",
  "lang.search": "Search language",
  "layout.install_app": "Install app",
  "layout.mcp_server": "MCP Server",
  "layout.nav_chat": "Chat",
  "layout.nav_settings": "Settings",
  "layout.privacy_policy": "Privacy Policy",
  "layout.sign_in": "Sign in",
  "layout.terms_of_service": "Terms of Service",
  "layout.toggle_menu": "Toggle menu",
  "layout.toggle_theme": "Toggle dark / light mode",
  "mcp.connected.app_body": "Your Bodygraph is here too. Ask about it in the chat, add the people around you and compare designs.",
  "mcp.connected.app_cta": "Open the chat",
  "mcp.connected.app_title": "Open the web app",
  "mcp.connected.finish_body": "Go back to {client} and start the connection again. If the earlier attempt is still waiting there, cancel it first — it cannot be resumed. The new one takes a single tap: your account and your Bodygraph are ready, so the approval screen has nothing left to ask.",
  "mcp.connected.finish_body_generic": "Go back to your assistant and start the connection again. If the earlier attempt is still waiting there, cancel it first — it cannot be resumed. The new one takes a single tap: your account and your Bodygraph are ready, so the approval screen has nothing left to ask.",
  "mcp.connected.finish_title": "Finish connecting in {client}",
  "mcp.connected.finish_title_generic": "Finish connecting your assistant",
  "mcp.connected.open_client": "Open {client}",
  "mcp.connected.open_guide": "See the connection steps",
  "mcp.connected.subtitle": "Your account is ready and your Bodygraph is calculated.",
  "mcp.connected.title": "You're all set",
  "nav.faq": "FAQ",
  "nav.features": "Features",
  "nav.home": "Home",
  "nav.pricing": "Pricing",
  "onboarding.consent.email": "Email me about new features and services",
  "onboarding.consent.tos_and": "and",
  "onboarding.consent.tos_prefix": "I agree to the",
  "onboarding.consent.tos_privacy": "Privacy Policy",
  "onboarding.consent.tos_terms": "Terms of Service",
  "onboarding.continue": "Continue",
  "onboarding.error.missing_fields": "Please fill in first name, birth date, and birth place.",
  "onboarding.error.time_required": "Please add a birth time, or tick “I don’t know my exact birth time”.",
  "onboarding.error.tos_required": "Please accept the Terms of Service and Privacy Policy to continue.",
  "onboarding.label.birth_date": "Birth date",
  "onboarding.label.birth_place": "Birth place",
  "onboarding.label.birth_time": "Birth time",
  "onboarding.label.name": "Your name",
  "onboarding.no_time_hint": "No worries — we'll use 12:00 noon. You can update it later on the People page.",
  "onboarding.no_time_label": "I don't know my exact birth time",
  "onboarding.placeholder.birth_place": "e.g. London, UK",
  "onboarding.placeholder.name": "e.g. Jane Doe",
  "onboarding.saving": "Saving…",
  "onboarding.subtitle": "Enter your birth details to calculate your Human Design Chart. You can always change this later.",
  "onboarding.title": "Welcome! Let's get started.",
  "penta.add_member": "Add person",
  "penta.aria_gate_empty": "Gate {gate} ({keynote}) — no one carries it",
  "penta.aria_gate_filled": "Gate {gate} ({keynote}) — carried by {names}",
  "penta.aria_strip": "Penta diagram: {defined} of 6 channels defined",
  "penta.back_to_groups": "Back to groups",
  "penta.blocked_time_body": "A Penta is built from every member's chart at once, so one guessed hour changes which channels the group is said to have. Set an exact time for {names} to see it.",
  "penta.blocked_time_title": "This Penta needs exact birth times",
  "penta.center_g": "G",
  "penta.center_g_role": "where the group is headed",
  "penta.center_sacral": "Sacral",
  "penta.center_sacral_role": "the energy that sustains it",
  "penta.center_throat": "Throat",
  "penta.center_throat_role": "how the group speaks & presents",
  "penta.channel.1-8": "Inspiration",
  "penta.channel.13-33": "The Prodigal",
  "penta.channel.2-14": "The Beat",
  "penta.channel.29-46": "Discovery",
  "penta.channel.5-15": "Rhythm",
  "penta.channel.7-31": "The Alpha",
  "penta.conscious": "conscious",
  "penta.fix_birth_time": "Set birth time",
  "penta.flow_fuel": "fuel",
  "penta.flow_voice": "voice",
  "penta.forming_title": "This Penta is still forming",
  "penta.gate.1": "Implementation",
  "penta.gate.13": "Accounting",
  "penta.gate.14": "Capacity",
  "penta.gate.15": "Reliability",
  "penta.gate.2": "Vision",
  "penta.gate.29": "Commitment",
  "penta.gate.31": "Administration",
  "penta.gate.33": "Oversight",
  "penta.gate.46": "Coordination",
  "penta.gate.5": "Culture",
  "penta.gate.7": "Planning",
  "penta.gate.8": "Public Relations",
  "penta.glyph_channels": "{defined}/6 channels",
  "penta.help_link": "What is a Penta?",
  "penta.kb_link": "Learn more",
  "penta.leadership_contested": "Contested",
  "penta.leadership_defined": "Defined",
  "penta.leadership_gap": "Gap",
  "penta.leadership_missing": "no one carries {gates}",
  "penta.line_label": "line {line}",
  "penta.load_failed": "Could not load the group's Penta.",
  "penta.not_found": "That group no longer exists.",
  "penta.remove_member": "Remove {name} from the group",
  "penta.remove_member_confirm": "Remove {name} from the group? They stay saved in your people.",
  "penta.rename_group": "Rename group",
  "penta.size_3": "3 members — a Penta forms, with natural tension",
  "penta.size_4": "4 members — the most stable Penta size",
  "penta.size_5": "5 members — the complete Penta",
  "penta.status_defined": "Defined",
  "penta.status_gap": "Gap",
  "penta.summary_defined": "Defined channels: {list}.",
  "penta.summary_gaps": "Gaps: {list}.",
  "penta.summary_gate": "Gate {gate} ({keynote}) is carried by {names}.",
  "penta.summary_gate_empty": "Gate {gate} ({keynote}) has no carrier.",
  "penta.tile_channels": "Channels",
  "penta.tile_defined": "defined",
  "penta.tile_fuel": "Fuel",
  "penta.tile_gap_one": "1 gap",
  "penta.tile_gaps_many": "{count} gaps",
  "penta.tile_gaps_none": "No gaps",
  "penta.tile_gen_covered": "5·14·29 ✓",
  "penta.tile_gen_missing": "missing {gates}",
  "penta.tile_leadership": "Leadership",
  "penta.tile_sacral": "{count} Sacral",
  "penta.tile_watch": "Watch",
  "penta.tip_gap_missing": "Missing gates: {gates}",
  "penta.tip_gate_title": "Gate {gate} — {keynote}",
  "penta.tip_half_held": "{name} half-holds this channel through gate {gate} and may feel pushed to fill the gap.",
  "penta.tip_half_held_many": "{names} half-hold this channel through gate {gate} and may feel pushed to fill the gap.",
  "penta.tip_missing": "No one carries this gate — the group feels {keynote} as something missing.",
  "penta.tip_only_carrier": "Only {name} carries this — if they leave, the function leaves with them.",
  "penta.tip_shared": "Carried by {count} members — reinforcement, or a quiet rivalry.",
  "penta.unconscious": "unconscious",
  "penta.watch_expression": "in the voice half",
  "penta.watch_flow_blocked": "fuel can't reach the voice",
  "penta.watch_foundation": "in the fuel half",
  "penta.watch_none": "fuel reaches the voice",
  "people.add_person": "Add person",
  "people.add_to_group": "Add to \"{name}\"",
  "people.analyse_group_query": "Analyse my group \"{name}\"",
  "people.analyse_in_chat": "Analyse in Chat",
  "people.back": "Back",
  "people.birth_date_range": "Please check the birth date — we can only calculate a chart for a birth between {min} and {max}.",
  "people.birth_date_recent": "That birth date is less than {years} years ago. Is the year right?",
  "people.birth_time_explorer_hint": "Drag the line, or click a time for details.",
  "people.birth_time_explorer_title": "Explore {name}'s birth day",
  "people.birth_time_load_failed": "The birth time explorer couldn't load. Please try again.",
  "people.birth_time_loading": "Mapping the whole birth day…",
  "people.birth_time_pro_badge": "Pro explorer",
  "people.birth_time_pro_body": "Free shows what stays trustworthy across the day. Pro reveals exactly how each activation and definition holds.",
  "people.birth_time_pro_centers": "Every center, including whether its defined state changes",
  "people.birth_time_pro_channels": "Every defined channel and its share of the day",
  "people.birth_time_pro_cta": "Explore with Pro",
  "people.birth_time_pro_gates": "Every active gate, measured across 24 hours",
  "people.birth_time_pro_title": "See the chart change, item by item",
  "people.birth_time_retry": "Try again",
  "people.birth_time_update": "Update birth time",
  "people.cancel": "Cancel",
  "people.chart_load_failed": "Couldn't load this chart. Please try again.",
  "people.chart_view_aria": "Person detail view",
  "people.chart_view_chart": "Chart",
  "people.chat_about": "Chat",
  "people.chip_dynamic": "What's the dynamic between {a} and {b}?",
  "people.chip_dynamic_me": "What's the dynamic between me and {name}?",
  "people.chip_work": "How should I work with {name}?",
  "people.create": "Create",
  "people.create_group": "Create group",
  "people.creating": "Creating…",
  "people.date_day": "Day",
  "people.date_month": "Month",
  "people.date_year": "Year",
  "people.delete_group": "Delete group",
  "people.delete_group_confirm": "Delete group \"{name}\"?",
  "people.discard": "Discard",
  "people.discard_confirm": "Discard your changes?",
  "people.download_pdf": "Download PDF",
  "people.edit": "Edit",
  "people.edit_person_title": "Edit {name}",
  "people.empty_hint": "No one saved yet — add someone to explore their Human Design.",
  "people.enter_name": "Enter a name.",
  "people.esc_hint": "or click outside to close",
  "people.expand_chart": "Expand bodygraph",
  "people.field_birth_date": "Birth date",
  "people.field_birth_place": "Birth place",
  "people.field_birth_time": "Birth time",
  "people.field_name": "Name",
  "people.fill_all_fields": "Please fill in all fields.",
  "people.filter_active": "Active filters",
  "people.filter_already_added": "Already added.",
  "people.filter_any": "Any",
  "people.filter_any_of": "has any of",
  "people.filter_button": "Filter",
  "people.filter_cant_tell": "Can't tell ({count})",
  "people.filter_cant_tell_hint": "Their birth time isn't exact enough to know. Open a person to see what it does settle.",
  "people.filter_centers_hint": "Tap a center to switch between defined, undefined and any.",
  "people.filter_channel_invalid": "No channel matches. Type two gates, like 42-53.",
  "people.filter_channel_placeholder": "Type a gate or a channel, like 42-53",
  "people.filter_chip_authority": "{authority} authority",
  "people.filter_chip_channel": "Channel {channel}",
  "people.filter_chip_defined": "{center} defined",
  "people.filter_chip_gate": "Gate {gate}",
  "people.filter_chip_profile": "Profile {profile}",
  "people.filter_chip_undefined": "{center} undefined",
  "people.filter_clear": "Clear all",
  "people.filter_count": "{matched} of {total} match",
  "people.filter_done": "Done",
  "people.filter_enter_key": "Enter",
  "people.filter_gate_invalid": "A gate is a number from 1 to 64.",
  "people.filter_gate_placeholder": "Type a gate number, 1–64",
  "people.filter_no_match": "Nobody you've saved matches these filters.",
  "people.filter_remove": "Remove {filter}",
  "people.filter_suggest": "Filter: {filter}",
  "people.filter_title": "Filter people",
  "people.group_actions_unavailable": "Group actions are temporarily unavailable while the latest data reloads.",
  "people.group_add_more_hint": "Add {count} more to analyse",
  "people.group_member_count": "{count}/5 members",
  "people.group_member_needs_time": "Needs an exact birth time",
  "people.group_name_label": "Group name",
  "people.group_name_placeholder": "e.g. Family, Work Team",
  "people.group_search_label": "Search groups",
  "people.group_search_placeholder": "Search groups…",
  "people.groups_description": "Create a group of 3–5 people and ask AI to analyse the group's dynamics using Human Design Penta theory.",
  "people.groups_heading": "Groups",
  "people.groups_load_failed": "Could not load groups.",
  "people.groups_locked_text": "Analyse the dynamics of your family, team or friends using Human Design Penta theory.",
  "people.groups_no_match": "No groups match your search.",
  "people.groups_readonly_toast": "Groups are temporarily read-only until the latest refresh succeeds.",
  "people.groups_warning_disabled": "Group actions are disabled until the next refresh succeeds.",
  "people.groups_warning_readonly": "Showing your last synced groups in read-only mode.",
  "people.groups_warning_title": "Groups need support attention.",
  "people.hint_clash_me": "Why do {name} and I clash?",
  "people.hint_energy": "What energizes {name}?",
  "people.hint_feedback": "How do I give {name} feedback?",
  "people.hint_group_gap": "What energy is {name} missing?",
  "people.hint_group_lead": "Who takes the lead in {name}?",
  "people.hint_group_meetings": "How should {name} run meetings?",
  "people.is_me_change_note": "To change, mark someone else as \"This is me\".",
  "people.is_me_currently": "currently {me}",
  "people.is_me_note": "Only one person can be \"This is me\". Checking this will replace the current one.",
  "people.is_me_replaces": "replaces {me}",
  "people.keep_editing": "Keep editing",
  "people.loading_chart": "Loading chart…",
  "people.manage_sharing": "Manage sharing",
  "people.member_me": "{name} (me)",
  "people.more_actions": "More actions",
  "people.name_placeholder": "e.g. John Doe",
  "people.new_group": "New group",
  "people.no_match": "No people match your search.",
  "people.no_more_people": "No more people to add. Add people first.",
  "people.own_bodygraph_not_removable": "This is your own bodygraph, so it can't be removed. Edit its birth details instead, or mark someone else as \"This is me\".",
  "people.page_header": "People, Pairs & Groups",
  "people.pairs_heading": "Pairs",
  "people.pdf_failed": "Couldn't create the PDF. Please try again.",
  "people.people_description": "Save the people whose Human Design you want to explore, then refer to them by first name in chat.",
  "people.people_heading": "People",
  "people.place_clear": "Clear place",
  "people.place_placeholder": "e.g. London, UK",
  "people.preparing_pdf": "Preparing PDF…",
  "people.remove": "Remove",
  "people.remove_confirm": "Remove {name}?",
  "people.remove_failed": "Couldn't remove this person. Please try again.",
  "people.remove_member_action": "Remove member…",
  "people.remove_this_person_confirm": "Remove this person?",
  "people.save": "Save",
  "people.saved_refresh_failed": "Saved, but failed to refresh the updated chart. Please try again.",
  "people.saving": "Saving…",
  "people.search_label": "Search people",
  "people.search_placeholder": "Search people…",
  "people.share": "Share",
  "people.share_desc": "Anyone with the link will see this person's name, birth date, and birth place.",
  "people.share_link_copied": "Share link copied to clipboard",
  "people.share_link_failed": "Couldn't create the share link. Please try again.",
  "people.share_link_fallback": "Share link: {url}",
  "people.share_person_title": "{name} — Human Design",
  "people.share_sheet_title": "Human Design chart",
  "people.share_title": "Share this chart",
  "people.shared_desc": "Anyone with the link can view this chart.",
  "people.show_mandala": "Show mandala",
  "people.something_went_wrong": "Something went wrong. Please try again.",
  "people.stage_view_detailed": "Detailed",
  "people.stage_view_sky": "Sky",
  "people.stop_sharing_failed": "Couldn't stop sharing. Please try again.",
  "people.tab_advanced": "Advanced",
  "people.tab_birth_time": "Birth time",
  "people.tab_bodygraph": "Bodygraph",
  "people.tab_overview": "Overview",
  "people.tab_planets": "Planets",
  "people.temp_chart_name": "Temporary chart",
  "people.temp_chart_unavailable": "Temporary chart is no longer available.",
  "people.this_is_me": "This is me",
  "people.this_person": "this person",
  "people.time_approx_short": "approx.",
  "people.time_choice_exact": "Exact time",
  "people.time_choice_roughly": "Roughly",
  "people.time_choice_unknown": "No idea",
  "people.time_hour": "Hour",
  "people.time_minute": "Minutes",
  "people.time_period": "AM or PM",
  "people.time_picker": "Pick a time",
  "people.time_required": "Please add a birth time, or pick “No idea” if you don't know it.",
  "people.time_roughly_hint": "Your best guess, give or take 3 hours.",
  "people.time_unknown_short": "time unknown",
  "people.unknown_error": "unknown error",
  "people.unknown_time_hint": "We'll use 12:00 noon.",
  "people.upgrade_to_pro": "Upgrade to Pro",
  "people.you_pill": "You",
  "pwa.appstore_note_text": "Get the app for iPhone and iPad and sign in with this account. Everything you've saved is there.",
  "pwa.appstore_note_text_pro": "Get the app for iPhone and iPad and sign in with this account. Your Pro subscription comes with you, so there's nothing to buy again.",
  "pwa.appstore_note_title": "Human Design is now in the App Store",
  "pwa.banner_appstore_hint": "Our app for iPhone and iPad is in the App Store.",
  "pwa.banner_install": "Install",
  "pwa.banner_play_hint": "Install our Android app for a faster, more reliable experience.",
  "pwa.banner_prompt_hint": "Add to your home screen for a full-screen experience",
  "pwa.banner_title": "Get the app",
  "pwa.get_on_play": "Get it on Google Play",
  "pwa.migrate_text": "We've launched on Google Play. Install it for a faster, more reliable app, then remove this old shortcut.",
  "pwa.migrate_title": "Our app is now on Google Play",
  "pwa.qr_hint": "Scan the QR code with your phone's camera to get the app — from the App Store on iPhone and iPad, or from Google Play on Android.",
  "pwa.qr_hint_prelaunch": "Scan the QR code with your phone's camera to get the app — from Google Play on Android, or added to your home screen on iPhone.",
  "pwa.qr_scan_short": "Scan the QR code with your phone's camera — our app is in the App Store and on Google Play.",
  "pwa.qr_scan_short_prelaunch": "Scan the QR code with your phone's camera — our Android app is on Google Play.",
  "pwa.qr_title": "Get the app on your phone",
  "quota.reset_passed": "Your limit has reset. Please reload the page.",
  "quota.resets": "Resets {relative} · {when}",
  "settings.about.api_status": "System status",
  "settings.about.contact": "We'd love to hear from you. Reach out at",
  "settings.about.privacy": "Privacy Policy",
  "settings.about.terms": "Terms of Service",
  "settings.assistants.connect": "Connect an assistant",
  "settings.assistants.connect_another": "Connect another assistant",
  "settings.assistants.connect_another_desc": "The same account works in as many as you like",
  "settings.assistants.connected_on": "Connected {date}",
  "settings.assistants.empty_body": "Connect an assistant and it can read your Bodygraph, save the people around you and compare designs — inside whatever you already chat in.",
  "settings.assistants.empty_cta": "See how to connect",
  "settings.assistants.empty_title": "Use gethumandesign with any AI assistant",
  "settings.assistants.how": "How it works",
  "settings.assistants.status_desc": "Check whether everything is running right now",
  "settings.assistants.status_open": "Open",
  "settings.assistants.unnamed": "Unnamed app",
  "settings.badge.free": "Free",
  "settings.badge.pro": "Pro",
  "settings.checkout.open_in_app": "Open in the app",
  "settings.color_scheme.dark": "Dark",
  "settings.color_scheme.heading": "Color scheme",
  "settings.color_scheme.light": "Light",
  "settings.color_scheme.system": "System",
  "settings.data.description": "One ZIP file with your account, people, groups and conversations.",
  "settings.data.download": "Download (ZIP, {size})",
  "settings.data.download_failed": "The download could not start. Please try again in a moment.",
  "settings.data.download_no_size": "Download (ZIP)",
  "settings.data.failed": "We couldn't build your export. Please try again. If it fails again, email hello@gethumandesign.com.",
  "settings.data.heading": "Download your data",
  "settings.data.new_desc": "A new export includes everything saved since.",
  "settings.data.next_at": "You can request a new export after {time}.",
  "settings.data.preparing": "Preparing your export. We'll email you at {email} when it's ready — you can close this page.",
  "settings.data.preparing_no_email": "Preparing your export. We'll email you when it's ready — you can close this page.",
  "settings.data.ready": "Your export is ready. It stays available until {date}.",
  "settings.data.ready_no_date": "Your export is ready.",
  "settings.data.request": "Request export",
  "settings.data.request_failed": "Your export could not be requested. Please try again in a moment.",
  "settings.data.request_new": "Request a new export",
  "settings.data.retry": "Try again",
  "settings.delete.apple_warning": "Deleting your account does not cancel your App Store subscription. Cancel it in the App Store first, or Apple keeps charging you.",
  "settings.delete.cancel": "Cancel",
  "settings.delete.confirm_button": "Delete permanently",
  "settings.delete.confirm_label": "Type {word} to confirm:",
  "settings.delete.confirm_word": "DELETE",
  "settings.delete.deleting": "Deleting…",
  "settings.delete.description": "Delete your account and everything saved in it.",
  "settings.delete.download_first": "Download your data first",
  "settings.delete.google_play_warning": "Your Google Play subscription will be cancelled and won't renew. The current period is not refunded.",
  "settings.delete.heading": "Delete account",
  "settings.delete.link": "Delete…",
  "settings.delete.pro_warning": "Your Pro subscription will be cancelled immediately with no refund.",
  "settings.delete.reason.found_alternative": "I found an alternative",
  "settings.delete.reason.missing_feature": "It was missing a feature I needed",
  "settings.delete.reason.not_using_it": "I wasn't using it enough",
  "settings.delete.reason.other": "Another reason",
  "settings.delete.reason.privacy": "Privacy concerns",
  "settings.delete.reason.too_confusing": "I couldn't work out how to use it",
  "settings.delete.reason.too_expensive": "Too expensive",
  "settings.delete.survey.anonymous_note": "Your answer is stored anonymously — nothing links it back to you or your account. Please leave out names, email addresses and anything else personal.",
  "settings.delete.survey.comment_label": "Anything you'd like to add?",
  "settings.delete.survey.heading": "What made you leave?",
  "settings.delete.survey.optional": "Optional",
  "settings.delete.warning": "This permanently deletes your account and all associated data. It cannot be undone.",
  "settings.email.cancel": "Cancel",
  "settings.email.changed_toast": "Your email address is now {email}.",
  "settings.email.check_inbox": "Open the link we sent to {email} to finish the change.",
  "settings.email.edit": "Change",
  "settings.email.heading": "Email",
  "settings.email.provider_note": "Signed in with {provider}. Your address comes from your {provider} account.",
  "settings.email.provider_note_relay": "Signed in with {provider}. Apple forwards email from this private address to your inbox.",
  "settings.email.send": "Send link",
  "settings.email.send_failed": "We couldn’t send the link. Please try again.",
  "settings.email.sending": "Sending…",
  "settings.email_lists.failed": "Couldn't save that. Try again.",
  "settings.email_lists.getting_started": "Getting started",
  "settings.email_lists.getting_started_desc": "A few notes in your first week.",
  "settings.email_lists.note": "Account and billing emails always arrive; they have no switch.",
  "settings.email_lists.paused": "Emails paused",
  "settings.email_lists.paused_desc": "Your inbox turned away our last three emails, usually because it's full. We've stopped sending until you resume.",
  "settings.email_lists.paused_resume": "Resume",
  "settings.email_lists.product_updates": "Product updates",
  "settings.email_lists.product_updates_desc": "What's new, a few times a year.",
  "settings.email_lists.sky_weekly": "Your sky this week",
  "settings.email_lists.sky_weekly_desc": "Next week's transits for you and your people, by email on Sunday at 20:00 your time.",
  "settings.email_lists.sky_weekly_needs_time": "Needs your own exact birth time.",
  "settings.email_lists.sky_weekly_on": "On. Sundays at 20:00, {zone}.",
  "settings.email_lists.sky_weekly_paused": "Paused while you're on Free.",
  "settings.email_lists.sky_weekly_pro": "Part of Pro.",
  "settings.help.contact": "Contact us",
  "settings.knowledge_level.advanced": "Advanced",
  "settings.knowledge_level.beginner": "Beginner",
  "settings.knowledge_level.description": "AI replies match your experience level.",
  "settings.knowledge_level.heading": "Knowledge level",
  "settings.knowledge_level.intermediate": "Intermediate",
  "settings.knowledge_level.unset": "Explain terms",
  "settings.language.auto": "Automatic (device)",
  "settings.language.description": "The language of the app, the chat's replies and our emails.",
  "settings.language.heading": "Language",
  "settings.loading": "Loading...",
  "settings.log_out.description": "Sign out on this device.",
  "settings.name.add": "Add your birth data",
  "settings.name.cancel": "Cancel",
  "settings.name.edit": "Edit",
  "settings.name.heading": "Name",
  "settings.name.person_link": "Birth details",
  "settings.name.save": "Save",
  "settings.name.save_failed": "Failed to save",
  "settings.name.saving": "Saving…",
  "settings.pro.billed_apple": "Billed through the App Store.",
  "settings.pro.billed_google_play": "Billed through Google Play.",
  "settings.pro.billed_none": "Nothing is billed.",
  "settings.pro.billed_stripe": "Billed on gethumandesign.com through Stripe.",
  "settings.pro.billing_monthly": "Monthly",
  "settings.pro.billing_yearly": "Yearly",
  "settings.pro.ends_on": "Your Pro plan ends on {date}.",
  "settings.pro.features_line": "Unlimited charts &amp; chat · Transits, cycles and returns · Penta group analysis · Advanced features · Our deepest AI readings",
  "settings.pro.gifted": "Gifted",
  "settings.pro.gifted_badge": "Gifted until {date}",
  "settings.pro.issue_on_hold_apple": "Pro is paused: your last payment didn't go through. Update your payment method in the App Store and Pro comes back on its own.",
  "settings.pro.issue_on_hold_google_play": "Pro is paused: your last payment didn't go through. Update your payment method in Google Play and Pro comes back on its own.",
  "settings.pro.manage_app_store": "Manage in the App Store",
  "settings.pro.manage_google_play": "Manage in Google Play",
  "settings.pro.manage_on_web": "Manage or cancel on the web",
  "settings.pro.manage_subscription": "Manage subscription",
  "settings.pro.member_since": "Member since {date}",
  "settings.pro.renews_on": "Renews on {date}.",
  "settings.pro.resume_hint": "Changed your mind? Use Manage subscription above to resume.",
  "settings.pro.switch_not_here": "This subscription isn't on the Google account Google Play uses on this device. Manage it in Google Play instead.",
  "settings.pro.switch_to_monthly": "Switch to monthly in Google Play",
  "settings.pro.switch_to_yearly": "Switch to yearly in Google Play",
  "settings.pro.switched": "Your plan has been switched.",
  "settings.pro.your_plan": "Your plan",
  "settings.reset": "Reset",
  "settings.section.account": "Account",
  "settings.section.assistants": "AI assistants",
  "settings.section.email": "Email",
  "settings.section.help": "Help",
  "settings.section.plan": "Plan",
  "settings.section.preferences": "Preferences",
  "settings.title": "Settings",
  "settings.tz.checking": "Checking…",
  "settings.tz.country_narrow": "Spans about {hours} hours of clock time — add a city or region",
  "settings.tz.no_locations": "No locations found",
  "settings.tz.not_found": "Location not found",
  "settings.tz.rate_limited": "Too many searches in a row — wait a moment, then keep typing.",
  "settings.tz.search_busy": "The place search is busy — wait a moment, then keep typing.",
  "settings.tz.search_failed": "Couldn't search just now. Check your connection and try again.",
  "settings.tz.searching": "Searching…",
  "settings.upgrade.billed_as_year": "billed as {price} / year",
  "settings.upgrade.billing_period": "Billing period",
  "settings.upgrade.billing_unavailable": "Purchases are unavailable right now. Please try again in a few minutes.",
  "settings.upgrade.cancel_anytime_prefix": "Cancel anytime. Not satisfied?",
  "settings.upgrade.cancel_anytime_suffix": "— we'll work it out.",
  "settings.upgrade.converted_from_month": "converted from {price} / month",
  "settings.upgrade.converted_from_year": "converted from {price} / year",
  "settings.upgrade.email_us": "Email us",
  "settings.upgrade.feature.advanced_data": "Advanced features — Color, Tone and Base, your full Variable (PHS and Rave Psychology), Cognition, Transference &amp; Distraction, your DreamRave sleep chart, Lilith &amp; Chiron",
  "settings.upgrade.feature.birth_time": "Birth-time precision — see which gates, channels and centers hold if your birth time is off",
  "settings.upgrade.feature.group_analysis": "Penta group analysis — how a family, friend group or team works together",
  "settings.upgrade.feature.smarter_chat": "Our deepest AI readings, from our strongest model",
  "settings.upgrade.feature.transits": "Transits, cycles and returns — what the sky does to your bodygraph, for any date or period",
  "settings.upgrade.hit_limit": "You've hit your limit",
  "settings.upgrade.hit_limit_desc": "Upgrade now to keep making requests, or wait for your limit to reset.",
  "settings.upgrade.hit_limit_desc_twa": "You've reached your free limit — it resets soon. Go Pro for unlimited.",
  "settings.upgrade.ios_deliver_failed": "Your payment went through, but we couldn't confirm it yet. Pro switches on automatically — reopen the app if it isn't there in a few minutes.",
  "settings.upgrade.ios_failed": "The purchase didn't go through. Please try again.",
  "settings.upgrade.ios_length_monthly": "1-month subscription, renews automatically",
  "settings.upgrade.ios_length_yearly": "1-year subscription, renews automatically",
  "settings.upgrade.ios_not_eligible": "This account already has Pro, so there is nothing to buy here.",
  "settings.upgrade.ios_nothing_to_restore": "No App Store subscription was found for this Apple ID.",
  "settings.upgrade.ios_other_account": "This App Store subscription already belongs to another GetHumanDesign account. Sign in with that account to use Pro, or manage the subscription in the App Store.",
  "settings.upgrade.ios_pending": "Your purchase is waiting for approval. Pro switches on as soon as it is approved.",
  "settings.upgrade.ios_per_month_yearly": "{price} / month, billed yearly",
  "settings.upgrade.ios_renewal": "Payment is charged to your Apple ID. The subscription renews automatically unless you cancel it in your App Store settings at least 24 hours before the period ends.",
  "settings.upgrade.ios_restore": "Restore purchases",
  "settings.upgrade.ios_restored": "Your purchase is restored. Welcome back to Pro.",
  "settings.upgrade.ios_subscribe": "Subscribe",
  "settings.upgrade.ios_unavailable": "The App Store can't be reached right now. Please try again later.",
  "settings.upgrade.ios_welcome": "Welcome to Pro! Everything is unlocked.",
  "settings.upgrade.manage_on_web": "Your plan and billing are managed on the web.",
  "settings.upgrade.monthly": "Monthly",
  "settings.upgrade.not_eligible_apple": "This account already has Pro through the App Store, so there is nothing to buy here.",
  "settings.upgrade.not_eligible_google_play": "This account already has Pro through Google Play, so there is nothing to buy here.",
  "settings.upgrade.not_eligible_stripe": "This account already has Pro through the website, so there is nothing to buy here.",
  "settings.upgrade.now_btn": "Upgrade now",
  "settings.upgrade.open_account": "Manage your plan on the web",
  "settings.upgrade.opening_checkout": "Opening secure checkout…",
  "settings.upgrade.per_month": "/ month",
  "settings.upgrade.per_year": "/ year",
  "settings.upgrade.play_needs_chrome": "Purchases in the app need Google Chrome as your default browser. Set Chrome as the default in your phone's settings.",
  "settings.upgrade.play_not_now": "Pro can't be bought in the app right now. Please try again later.",
  "settings.upgrade.play_other_account": "This Google account already pays for Pro on another GetHumanDesign account. Sign in with that account to use it, or choose a different Google account in Google Play to subscribe here.",
  "settings.upgrade.play_renewal": "Payment is charged to your Google Play account. The subscription renews automatically until you cancel it in Google Play.",
  "settings.upgrade.play_unavailable": "Google Play can't be reached right now. Please try again later.",
  "settings.upgrade.store_prices_note": "In the iPhone and Android apps, Pro costs {monthly} a month or {yearly} a year (the app stores take a commission).",
  "settings.upgrade.to_pro": "Upgrade to Pro",
  "settings.upgrade.to_pro_desc": "Unlimited charts and chat.",
  "settings.upgrade.yearly": "Yearly",
  "settings.usage.chat_messages": "Chat messages this period",
  "settings.usage.connect_ai": "connect your AI",
  "settings.usage.limit_reached": "Limit reached.",
  "settings.usage.load_error": "Could not load usage",
  "settings.usage.mcp_requests": "MCP Server requests this period",
  "share.copy_link": "Copy link",
  "share.create_link": "Create link",
  "share.link_copied": "Link copied to clipboard",
  "share.native": "Share…",
  "share.shared_via_link": "Shared via link",
  "share.stop_sharing": "Stop sharing",
  "stage.time_aria": "Move the sky through time",
  "stage.time_hint": "Drag, or use the arrow keys, to move the sky from yesterday to two weeks ahead",
  "stage.time_now": "Now",
  "stage.time_now_title": "Back to the moment this reading is for",
  "stage.time_pending": "Reading the days around this moment…",
  "transits.add_yourself": "Add yourself",
  "transits.ask_sun": "What does the Sun in gate {gate} mean for me right now?",
  "transits.ask_sun_named": "What does the Sun in gate {gate} mean for {name} right now?",
  "transits.ask_today": "What is the sky doing to my Bodygraph today?",
  "transits.ask_today_named": "What is the sky doing to {name}'s Bodygraph today?",
  "transits.ask_week": "Which of my open centers is activated this week, and until when?",
  "transits.ask_week_named": "Which of {name}'s open centers is activated this week, and until when?",
  "transits.change_begins": "{channel} begins ({kind})",
  "transits.change_begins_for": "{channel} begins ({kind}), for {duration}",
  "transits.change_defined_many": "{centers} activated",
  "transits.change_defined_one": "{center} activated",
  "transits.change_ends_many": "{channels} end",
  "transits.change_ends_one": "{channel} ends",
  "transits.change_opened_many": "{centers} open again",
  "transits.change_opened_one": "{center} open again",
  "transits.change_person": "Change person",
  "transits.change_turns": "{channel} turns {kind}",
  "transits.coming_empty": "Nothing changes on your bodygraph in this window.",
  "transits.coming_heading": "Coming up",
  "transits.coming_more": "Show {count} more",
  "transits.error_retry": "Try again",
  "transits.error_sub": "Please try again in a moment. If it keeps happening, email hello@gethumandesign.com and we'll look into it.",
  "transits.error_title": "The sky didn't load",
  "transits.fold_hide": "Hide",
  "transits.fold_many": "{count} long stays",
  "transits.fold_one": "1 long stay",
  "transits.fold_show": "Show",
  "transits.for_you_heading": "For you",
  "transits.for_you_sub": "Temporary, until the planets move on",
  "transits.forecast_days": "{days} days",
  "transits.forecast_hint": "Drag the line, or use the arrow keys, to look at any moment ahead. Then press Use this time to read the whole page for it.",
  "transits.forecast_range_label": "How far ahead",
  "transits.forecast_title": "The next {days} days",
  "transits.gist_defined": "Activated for you: {centers}.",
  "transits.gist_direct": "The sky completes {channels} in your bodygraph.",
  "transits.gist_label": "The sky in brief",
  "transits.gist_list_more": "{count} more",
  "transits.gist_next_at": "Next change {when}",
  "transits.gist_next_in": "Next change {rel}",
  "transits.gist_next_none": "No change to your bodygraph before {when}",
  "transits.gist_nothing": "The sky completes none of your channels at this moment.",
  "transits.kb_q_amplified_named": "The {planet} transit is sitting on {name}'s Channel {a}–{b} {when}, a channel they were born with. What does that amplification mean for {name}?",
  "transits.kb_q_amplified_self": "The {planet} transit is sitting on my Channel {a}–{b} {when}, a channel I was born with. What does that amplification mean for me?",
  "transits.kb_q_background_named": "The sky holds both ends of Channel {a}–{b} {when} ({planets}), so everyone has it. What does that background transit mean for {name}?",
  "transits.kb_q_background_self": "The sky holds both ends of Channel {a}–{b} {when} ({planets}), so everyone has it. What does that background transit mean for me?",
  "transits.kb_q_defines_named": "The {planet} transit is completing {name}'s Channel {a}–{b} {when}, which activates their open {center}. What does that mean for {name}?",
  "transits.kb_q_defines_self": "The {planet} transit is completing my Channel {a}–{b} {when}, which activates my open {center}. What does that mean for me?",
  "transits.kb_q_meets_named": "The {planet} transit is completing {name}'s Channel {a}–{b} {when}. What does that mean for {name}?",
  "transits.kb_q_meets_self": "The {planet} transit is completing my Channel {a}–{b} {when}. What does that mean for me?",
  "transits.kb_q_planet_named": "What does the {planet} transit in Gate {gate} mean for {name} {when}?",
  "transits.kb_q_planet_self": "What does the {planet} transit in Gate {gate} mean for me {when}?",
  "transits.kb_subject_channel": "the Channel {a}–{b} transit",
  "transits.kb_subject_planet": "the {planet} transit in Gate {gate}",
  "transits.kb_when_at": "on {date} at {time} ({zone})",
  "transits.kb_when_now": "right now",
  "transits.key_amplified": "Amplified",
  "transits.key_background": "Background",
  "transits.key_explain_amplified": "A planet is sitting on a channel you were born with. Nothing is added — what is already yours is louder.",
  "transits.key_explain_background": "The sky holds both ends of this channel, so everyone alive has it right now. It is the weather, not you.",
  "transits.key_explain_direct": "A planet is sitting in a gate that completes a channel you already half-hold. This is the one that can switch a center on.",
  "transits.key_sky": "Sky",
  "transits.leaves_gate": "Leaves {gate} {when}",
  "transits.letter_desc": "Next week's forecast, and your people's, on Sunday at 20:00 your time.",
  "transits.letter_label": "Email me this every Sunday",
  "transits.locked_sub": "See which gates the sky is activating, what they meet in your own chart, and how long each one lasts.",
  "transits.locked_title": "Transits are part of Pro",
  "transits.long_stay": "a long stay",
  "transits.lunar_aria": "The Moon's path through the nine centers over the next 28 days",
  "transits.lunar_failed": "The lunar month could not be loaded. Try again in a moment.",
  "transits.lunar_intro": "Made for Reflectors, whose decisions follow the lunar cycle. The Moon passes through all 64 gates in about 27 days. Each gate it enters sits in the row of its center, so you can follow its path through your bodygraph.",
  "transits.lunar_key_completes": "The Moon completes a channel",
  "transits.lunar_key_defined": "Center activated",
  "transits.lunar_key_natal": "A gate you were born with",
  "transits.lunar_key_passes": "The Moon completes nothing",
  "transits.lunar_learn": "Learn more:",
  "transits.lunar_link_authority": "Lunar Authority",
  "transits.lunar_link_cycle": "Reflectors and the lunar cycle",
  "transits.lunar_link_open_center": "When a transit activates an open center",
  "transits.lunar_readout_channels": "The Moon completes {channels}.",
  "transits.lunar_readout_defined": "{count} of 9 centers activated: {centers}.",
  "transits.lunar_readout_moon": "Moon in gate {gate} ({name}) · {center}",
  "transits.lunar_readout_open": "Every center is open.",
  "transits.lunar_title": "The lunar month",
  "transits.needs_time_action": "Set the birth time",
  "transits.needs_time_sub": "The sky crosses a gate in hours, so without the exact time we can't say what it meets in this bodygraph.",
  "transits.needs_time_title": "Set {name}'s exact birth time to see what the sky touches",
  "transits.next_at": "at {when}",
  "transits.next_in_hours": "in ~{hours} h",
  "transits.next_in_month": "in {month}",
  "transits.next_line": "Line {line} {when}",
  "transits.next_on": "on {date}",
  "transits.next_within_hour": "within the hour",
  "transits.no_people_sub": "Transits are the sky read against a bodygraph, so there has to be one to read it against.",
  "transits.no_people_title": "No one saved yet",
  "transits.nothing_touching": "Nothing in the sky is meeting your bodygraph right now. The week below shows when that changes.",
  "transits.others_line": "Background & amplified ({count})",
  "transits.pick_person_title": "Read the sky for",
  "transits.planet_in_gate": "{planet} in {gate}",
  "transits.retrograde": "retrograde",
  "transits.retrograde_mark": "R",
  "transits.retrograde_note": "Retrograde: from Earth the planet looks like it is moving backwards through the wheel. Ordinary, not a warning.",
  "transits.row_centers": "{a} to {b}",
  "transits.row_defined_for_you": "Activated for you: {centers}",
  "transits.row_on_yours": "{sky} · a gate you already have",
  "transits.row_sky_alone": "{sky} · the sky alone",
  "transits.row_then": "→ {kind} from {when}",
  "transits.row_with_yours": "{sky} + your {gate}",
  "transits.sky_heading": "Where the planets are",
  "transits.strip_aria": "Scrub through the week",
  "transits.strip_band_short": "{day} · {duration}",
  "transits.strip_centers": "Open centers the sky activates",
  "transits.strip_dur_days": "{n} d",
  "transits.strip_dur_hours": "{n} h",
  "transits.strip_dur_minutes": "{n} min",
  "transits.strip_gate": "Gate {gate}",
  "transits.strip_handle_now": "Now · {time}",
  "transits.strip_key_label": "What the marks mean",
  "transits.strip_key_now": "Now",
  "transits.strip_key_unknown": "Gate we can't name",
  "transits.strip_learn_more": "Learn more about transits",
  "transits.strip_nothing_defined": "Nothing of yours activated",
  "transits.strip_now": "Now",
  "transits.strip_open_time": "Read the sky at {time}",
  "transits.strip_pick_day": "Look at {day}",
  "transits.strip_planets": "Planets in the sky",
  "transits.strip_planets_toggle": "Show or hide the planet lanes",
  "transits.strip_read_completes": "Completes",
  "transits.strip_read_defined": "Activated for you",
  "transits.strip_read_defined_all": "Activated for everyone",
  "transits.strip_read_planets": "Planets",
  "transits.strip_tip_line": "Line {line}",
  "transits.strip_tip_range": "{from} to {to}",
  "transits.strip_use_time": "Use this time",
  "transits.strip_your_channels": "Your channels",
  "transits.tab_bodygraph": "Bodygraph",
  "transits.tab_forecast": "Forecast",
  "transits.tab_lunar": "Lunar",
  "transits.tab_moment": "Moment",
  "transits.title": "Transits",
  "transits.until": "until {when}",
  "transits.views_label": "Transits view",
  "transits.weekday_fri": "Fri",
  "transits.weekday_mon": "Mon",
  "transits.weekday_sat": "Sat",
  "transits.weekday_sun": "Sun",
  "transits.weekday_thu": "Thu",
  "transits.weekday_tue": "Tue",
  "transits.weekday_wed": "Wed",
  "transits.when_now": "Now",
  "transits.when_pick_moment": "Pick a date and time",
  "transits.when_reset": "Back to now",
  "transits.zone_note": "Times are local to {zone}."
};
